/* eslint-disable no-useless-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable no-else-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  TextField,
  Typography,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  Popover,
  DialogContentText,
  Tooltip
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import numeral from 'numeral';
import { Form, Formik, useFormikContext } from 'formik';
import React, { useContext, useEffect, useMemo, useState, useLayoutEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import InfoIcon from '@mui/icons-material/Info';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Container } from 'reactstrap';
import imagepreview from '../../../media/upload.png';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import '../../stylemod.css';
import TermsAndCondition from '../../Others/TermsAndCondition'
import cardImg from '../../../media/Images/popUpImg1.jpg';
import NoimageFound from '../../../media/noimage.jpg';




const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const shipMentTypesforIN = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
];

const shipMentTypesforUK = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
  { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
];

const shipMentTypesforSL = [
  { label: 'Air Cargo - OverAll', value: 'ACO'},
];

const DocTypes = [
  { label: 'Document', value: 'Document' },
  { label: 'NonDocument', value: 'NonDocument' },
];

const pickupTypes = [
  { label: 'Collection', value: 'C' },
  { label: 'Drop', value: 'D' },
];

const DimensionType = [
  { label: 'CM', value: 'CM' },
  { label: 'Inch', value: 'Inch' },
];

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
  { id: 9, name: 'NIC' },
  { id: 10, name: 'Residence Permit' },
];

const resetStates = {
  // indital data
  shipMentType: 'ACSL',
  docType: 'NonDocument',
  branch: '',
  NofoBoxes: 1,
  // sender details
  senderName: '',
  senderAddr1: '',
  senderAddr2: '',
  senderAddr3: '',
  senderCity: '',
  senderState: '',
  senderCountry: '',
  senderPincode: '',
  senderPhone: '',
  senderEmail: '',
  idCardType: '',
  IdCardNo: '',
  IDcardFile: null,
  // receiver details
  receiverName: '',
  receiverAddr1: '',
  receiverAddr2: '',
  receiverAddr3: '',
  receiverCity: '',
  receiverState: '',
  receiverCountry: '',
  receiverPincode: '',
  receiverPhone: '',
  receiverEmail: '',
  RecidCardType: '',
  RecIdCardNo: '',
  RecIDcardFile: null,
  source: 'Export',
  shipper: '',
  // collection details
  pickUpType: 'C',
  // collectionDate: '',
  acceptTerms: false,
  dimensionType: 'CM',
  senderAlterPhone: '',
  receiverAlterPhone: '',
  receiverId: '',
};

const CourierOrderCreation = () => {
  const { Type, EditId, ShipType, Status } = useParams();
  const configuration = {
    headers: {
      Country: sessionStorage.getItem('Origin'),
    },
  };
  const isDisabled = String(Status).trim().toUpperCase() === 'A';
  const classes = useStyles();
  const navigate = useNavigate();
  const { openSnackBar, showLoading, hideLoading, navOpen } = useContext(UIContext);
  const Origin = sessionStorage.getItem('Origin');
  const [initialValue, setInitialValue] = useState(resetStates);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [senderStateList, setSenderStateList] = useState([]);
  const [receiverStateList, setReceiverStateList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreviews, setImagePreviews] = useState({});
  // Separate sender/receiver image files and previews
  const [senderImageFile, setSenderImageFile] = useState(null);
  const [receiverImageFile, setReceiverImageFile] = useState(null);
  const [senderImagePreview, setSenderImagePreview] = useState('');
  const [receiverImagePreview, setReceiverImagePreview] = useState('');
  const [previewTarget, setPreviewTarget] = useState(null);
  const [editID, setEditID] = useState('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialog1, setOpenConfirmDialog1] = useState(false);
  const [boxToDelete, setBoxToDelete] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteOrderId, setDeleteOrderId] = useState(null);

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];
  const [boxCount, setBoxCount] = useState(sessionStorage.getItem('Origin') === 'UK' ? 1 : 0);
  const [boxDetails, setBoxDetails] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const [termsConditions, setTermsConditions] = useState([]);
  const [bookingStarted, setBookingStarted] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [uomList, setUOMList] = useState([]);
  // const [defaultUOMList, setDefaultUOMList] = useState([]);
  const [sameAsSender, setsameAsSender] = useState(false);
  const [receiverCountryErr, setreceiverCountryErr] = useState(false);
  const [senderCountryErr, setsenderCountryErr] = useState(false);
  const [receiverCountryId, setReceiverCountryId] = useState();
  const [shipperPriceData, setShipperPriceData] = useState([]);
  const [cardToggle, setCardToggle] = useState(false);
  const [changeContent, setChangeContent] = useState('');
  const [selectedGoods, setSelectedGoods] = useState(null);
  const [documentType, setDocumentType] = useState('NonDocument');
  const [submitConfirmation, setSubmitConfirmation] = useState(false);
  const [resetOpenDialog, setResetOpenDialog] = useState(false);
  const [senderSecondaryCountryId, setSenderSecondaryCountryId] = useState();
  const boxDetailsTempRef = useRef(null); // Holds the initial data // Temporary State to send mail in edit mode
  const formikRef = useRef(null);
  const latestValuesRef = useRef(resetStates);
  const pendingUnloadRef = useRef(false);
  const boxDetailsDirtyRef = useRef(false);
  const boxDetailsInitializedRef = useRef(false);
  const boxDetailsRef = useRef([]);
  const saveInProgressRef = useRef(false);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const contentRef = useRef(null);
  const [cancelRemarksText, setCancelRemarksText] = useState('');
  const [orderCancel, setOrderCancel] = useState('');
  const [receiverList, setReceiverList] = useState([]);
  const fieldRefs = useRef({});

  const [isloadvisible, setIsLoadVisible] = useState(true);
  const [openDialogPreview, setOpenDialogPreview] = useState(false);
  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [shipperId,setShipperId] = useState(0);
  const [isMinimized, setIsMinimized] = useState(false);
  const [hideUom,setHideUom] = useState(true)
  const [isDraft,setIsDraft] = useState(true)
 const [tc,setTC] = useState(false)
 const [boxLoadEnabled, setBoxLoadEnabled] = useState({});

 // Helper functions for dimension and weight validation
 const checkOversizeCondition = (boxes) => {
   return boxes.some(box => 
     (box.length && box.length >= 100) || 
     (box.width && box.width >= 100) || 
     (box.height && box.height >= 100)
   );
 };

 const checkOverweightCondition = (boxes) => {
   return boxes.some(box => box.grossWeight && box.grossWeight >= 31);
 };

 const showOversizeWarning = () => {
     openSnackBar('Additional charges will be applied for oversized shipments', 'warning');
 };

 const showOverweightWarning = () => {
     openSnackBar('Additional charges will be applied for overweight shipments', 'warning');
 };

 const [showIdCardChangeDialog, setShowIdCardChangeDialog] = useState({
   sender: false,
   receiver: false
 });
 const [pendingIdCardChanges, setPendingIdCardChanges] = useState({
   sender: null,
   receiver: null
 });
 const[sendPreviewBtn,setSendPreviewBtn] = useState(true);
 const[receivPreviewBtn,setReceivPreviewBtn] = useState(true);

  useEffect(() => {
    boxDetailsRef.current = boxDetails;
  }, [boxDetails]);

  useEffect(() => {
    if (!bookingStarted) {
      boxDetailsDirtyRef.current = false;
      boxDetailsInitializedRef.current = false;
      return;
    }

    if (!boxDetailsInitializedRef.current) {
      boxDetailsInitializedRef.current = true;
      if (Type !== 'Edit' && boxDetails.length > 0) {
        boxDetailsDirtyRef.current = true;
      }
      return;
    }

    boxDetailsDirtyRef.current = true;
  }, [boxDetails, bookingStarted, Type]);

  const buildCourierPayload = (values, draftFlag, details) => {
    const data = {
      OPTYPE: Type === 'Edit' ? 'Edit' : 'New',
      COURIER_ID: Type === 'Edit' ? EditId : 0,
      COMPANY_ID: sessionStorage.getItem('CompanyId'),
      BRANCH_ID: values.branch,
      CUSTOMER_ID: sessionStorage.getItem('UserId'),
      SHIPMENT_TYPE: ShipType || values.shipMentType,
      DOC_TYPE: values.docType,
      NO_OF_BOXES: values.NofoBoxes,
      SENDER_NAME: values.senderName,
      SENDER_ADDRESS1: values.senderAddr1,
      SENDER_ADDRESS2: values.senderAddr2,
      SENDER_ADDRESS3: values.senderAddr3,
      SENDER_CITY: values.senderCity,
      SENDER_STATE: values.senderState,
      SENDER_COUNTRY: values.senderCountry,
      SENDER_PINCODE: values.senderPincode,
      SENDER_CONTACTNO: values.senderPhone,
      SENDER_EMAILID: values.senderEmail,
      SENDER_IDCARD_TYPE: values.idCardType,
      SENDER_IDCARD_NO: values.IdCardNo,
      SENDER_IDCARD_NAME: getIdCardNameById(values.idCardType) || '',
      SENDER_IDCARD_IMAGE: senderImageFile,
      RECEIVER_NAME: values.receiverName,
      RECEIVER_ADDRESS1: values.receiverAddr1,
      RECEIVER_ADDRESS2: values.receiverAddr2,
      RECEIVER_ADDRESS3: values.receiverAddr3,
      RECEIVER_CITY: values.receiverCity,
      RECEIVER_STATE: values.receiverState,
      RECEIVER_COUNTRY: values.receiverCountry,
      RECEIVER_PINCODE: values.receiverPincode,
      RECEIVER_CONTACTNO: values.receiverPhone,
      RECEIVER_EMAILID: values.receiverEmail,
      RECEIVER_IDCARD_TYPE: values.RecidCardType,
      RECEIVER_IDCARD_NO: values.RecIdCardNo,
      RECEIVER_IDCARD_NAME: getIdCardNameById(values.RecidCardType) || '',
      RECEIVER_IDCARD_IMAGE: receiverImageFile,
      SOURCE: values.source,
      SHIPPER_LINER_NAME: values.shipper,
      SHIPPER_LINER_ID: shipperId,
      COLLECTION: values.pickUpType,
      COLLECTIONDATE: new Date('1900-01-01').toISOString(),
      TERMSID: tc ? 2 : 0,
      CREATEDBY: sessionStorage.getItem('UserId'),
      CREATEDON: new Date().toISOString(),
      MODIFIEDBY: 0,
      MODIFIEDON: new Date('1900-01-01').toISOString(),
      APPROVAL: 'N',
      APPROVEDBY: 0,
      APPROVEDON: new Date('1900-01-01').toISOString(),
      sameAs_Sender: sameAsSender ? 'Y' : 'N',
      SE_OrderCancelReq: 'N',
      SEreassignId: 0,
      SALESEXECUTIVES: 0,
      DimensionType: values.dimensionType,
      SENDER_ALTERCONTACTNO: values.senderAlterPhone,
      RECEIVER_ALTERCONTACTNO: values.receiverAlterPhone,
      IsDraft: draftFlag,
    };

    const InsertCourierDtl = (details || []).map((box, boxIndex) => ({
      OPTYPE: Type === 'Edit' ? 'Edit' : 'New',
      BOXES: box.boxNo,
      CARTON_L: box.length || 0,
      CARTON_W: box.width || 0,
      CARTON_H: box.height || 0,
      CUBIC_WEIGHT: box.cubicWeight || '0',
      DimensionType: '',
      GROSS_WEIGHT: box.grossWeight || '0',
      NO_OF_ITEMS: box.noOfItems,
      SINO: (boxIndex + 1).toString(),
      InsertGoodsDtl: (box.goods || []).map((good, goodIndex) => {
        const isValidImage =
          (typeof good.image === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(good.image) && !/^Doc_/i.test(good.image)) ||
          (typeof good.image === 'object' && good.image instanceof Blob);

        return {
          GOODS_ID: good.GoodsId === undefined || good.GoodsId === '' ? 0 : good.GoodsId,
          GOODS_Name: good.goodsName,
          UOM_ID: good.UOM_Id,
          QUANTITY: good.quantity || 0,
          RATE: good.rate === '' ? 0 : good.rate,
          VALUE: good.value,
          BOX: (boxIndex + 1).toString(),
          ITEM_IMAGE: good.image ? good.image : '',
          ITEM_IMG: isValidImage ? 'I' : '',
          NEW_ITEM: good.newGoods || 'N',
          APPROVAL: 'N',
          APPROVEDBY: 0,
          APPROVEDON: new Date('1900-01-01').toISOString(),
          SINO: (goodIndex + 1).toString(),
        };
      }),
    }));

    return {
      ...data,
      InsertCourierDtl,
    };
  };

  const convertToFormData = (obj, form = new FormData(), parentKey = '') => {
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        const newKey = parentKey ? `${parentKey}[${key}]` : key;

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            convertToFormData(item, form, `${newKey}[${index}]`);
          });
        } else if (value instanceof File || value instanceof Blob) {
          form.append(newKey, value);
        } else if (value && typeof value === 'object') {
          convertToFormData(value, form, newKey);
        } else {
          form.append(newKey, value != null ? value : '');
        }
      }
    }
    return form;
  };

  const saveDraftOnUnload = () => {
    if (!isDraft) return;
    const values = latestValuesRef.current || initialValue;
    const payload = buildCourierPayload(values, 'Y', boxDetailsRef.current);
    const formData = convertToFormData(payload);
    const apiBaseUrl = axios.defaults.baseURL || '';
    const url = `${apiBaseUrl}/Transactions/Courier/InsertCourierHdr`;

    try {
      fetch(url, {
        method: 'POST',
        body: formData,
        keepalive: true,
        headers: {
          Country: sessionStorage.getItem('Origin'),
          authtoken: sessionStorage.getItem('authToken'),
        },
      });
    } catch (e) {
      // Best-effort draft save on unload.
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!bookingStarted || saveInProgressRef.current || !isDraft) return;
      const isDirty = Boolean(formikRef.current?.dirty || boxDetailsDirtyRef.current);
      if (!isDirty) return;

      pendingUnloadRef.current = true;
      event.preventDefault();
      event.returnValue = '';
    };

    const handlePageHide = () => {
      if (!pendingUnloadRef.current || saveInProgressRef.current || !isDraft) return;
      pendingUnloadRef.current = false;

      const isDirty = Boolean(formikRef.current?.dirty || boxDetailsDirtyRef.current);
      if (!isDirty) return;

      saveDraftOnUnload();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [bookingStarted, isDraft]);
  const handleValidationFlow = async (values, validateForm) => {
    // 1. Validate form using properly accessed values
    const errors = await validateForm(values);
    const errorPriority = [
      'senderName', 'senderPhone', 'senderEmail', 'senderAddr1', 'senderCity', 'senderPincode',
      'receiverName', 'receiverPhone', 'receiverAddr1', 'receiverCity', 'receiverPincode',
      'branch', 'acceptTerms', 'IdCardNo', 'RecIdCardNo'
    ];

    // Reorder errors according to priority
    const orderedErrors = {};
    errorPriority.forEach(field => {
      if (errors[field]) {
        orderedErrors[field] = errors[field];
      }
    });


    // 2. Handle error cases
    if (Object.keys(orderedErrors).length > 0) {
      console.log(orderedErrors, 'orderedErrors')
      const firstErrorKey = Object.keys(orderedErrors)[0];
      console.log(orderedErrors[firstErrorKey], 'orderedErrors')
      setTimeout(() => {
        openSnackBar(orderedErrors[firstErrorKey], 'error');
      }, 100);
      fieldRefs.current[firstErrorKey]?.focus();
      return;
    }

    // 3. Your existing special validations
    if (!validateBoxGoodsDetails(boxDetails)) return;

    if (Number(values.senderCountry) !== Number(senderSecondaryCountryId) && sameAsSender === true) {
      setOpenConfirmDialog1(true);
      const selectedCountry = countryList.find(d => Number(d.CountryId) === Number(values.senderCountry));
      const customerCountry = countryList.find(d => Number(d.CountryId) === Number(senderSecondaryCountryId));
      setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
          and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
      return;
    }

    setSubmitConfirmation(true);
  };

  const handleOpenDeleteDialog = () => {
    const idToDelete = Type === 'Edit' ? EditId : editID || null;
    if (!idToDelete) {
      openSnackBar('No order selected to delete', 'warning');
      return;
    }
    if (!isDraft) {
      openSnackBar('Only draft orders can be deleted', 'warning');
      return;
    }
    setDeleteOrderId(idToDelete);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteOrderId(null);
  };

  const deleteOrder = async () => {
    if (!deleteOrderId) return;
    try {
      showLoading();
      await axios.delete(`/Transactions/Courier/DeleteCourier/${deleteOrderId}`, {
        headers: { Country: Origin },
      });
      if(isDraft) {
        openSnackBar('Draft has been deleted successfully!');
      } else {
      openSnackBar('Order has been deleted successfully!');
      }
      navigate('/dashboard/manage/booking');
    } catch (e) {
      openSnackBar('Something went wrong', 'error');
    }
    hideLoading();
    handleCloseDeleteDialog();
  };

  const handleScroll = () => {
    const content = contentRef.current;
    if (content) {
      const isAtBottom = Math.abs(content.scrollHeight - content.scrollTop - content.clientHeight) <= 1;
      setIsScrolledToBottom(isAtBottom);
    }
  };

async function GetEditData(id) {
  try {
    const requestData = {
      CompanyId: sessionStorage.getItem('CompanyId'),
    };

    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
      },
    };
    showLoading();
    const response = await axios.get(`Transactions/Courier/GetAllCourier/${id}`, config);
    setBookingStarted(true);
    const courierHeader = response.data.courierHeader[0];
    const {courierDetail} = response.data;
    getSenderState(courierHeader.SENDER_COUNTRY);
    getReceiverState(courierHeader.RECEIVER_COUNTRY);
    setsameAsSender(courierHeader.sameAs_Sender === 'Y');
    setReceiverCountryId(courierHeader.RECEIVER_COUNTRY);
    setCardToggle(true);
    setSenderSecondaryCountryId(courierHeader.SENDERSec_COUNTRY)
    setCancelRemarksText(courierHeader.CancelRemarks)
    setOrderCancel(courierHeader.IsCancel);
    // eslint-disable-next-line no-unneeded-ternary
    setIsDraft(courierHeader.IsDraft === 'Y' ? true : false);
    setTC(Number(courierHeader.TERMS_ID) === 2 ? true : false);
    const updatedValues = {
      ...resetStates,
      shipMentType: courierHeader.SHIPMENT_TYPE || resetStates.shipMentType,
      docType: courierHeader.DOC_TYPE || resetStates.docType,
      branch: (Number(courierHeader.BRANCH_ID) !== 0 ? courierHeader.BRANCH_ID : resetStates.branch),
      NofoBoxes: courierHeader.NO_OF_BOXES || resetStates.NofoBoxes,
      senderName: courierHeader.SENDER_NAME || resetStates.senderName,
      senderAddr1: courierHeader.SENDER_ADDRESS1 || resetStates.senderAddr1,
      senderAddr2: courierHeader.SENDER_ADDRESS2 || resetStates.senderAddr2,
      senderAddr3: courierHeader.SENDER_ADDRESS3 || resetStates.senderAddr3,
      senderCity: courierHeader.SENDER_CITY || resetStates.senderCity,
      senderState: courierHeader.SENDER_STATE || resetStates.senderState,
      senderCountry: courierHeader.SENDER_COUNTRY || resetStates.senderCountry,
      senderPincode: courierHeader.SENDER_PINCODE || resetStates.senderPincode,
      senderPhone: courierHeader.SENDER_CONTACTNO || resetStates.senderPhone,
      senderEmail: courierHeader.SENDER_EMAILID || resetStates.senderEmail,
      receiverName: courierHeader.RECEIVER_NAME || resetStates.receiverName,
      receiverAddr1: courierHeader.RECEIVER_ADDRESS1 || resetStates.receiverAddr1,
      receiverAddr2: courierHeader.RECEIVER_ADDRESS2 || resetStates.receiverAddr2,
      receiverAddr3: courierHeader.RECEIVER_ADDRESS3 || resetStates.receiverAddr3,
      receiverCity: courierHeader.RECEIVER_CITY || resetStates.receiverCity,
      receiverState: courierHeader.RECEIVER_STATE || resetStates.receiverState,
      receiverCountry: courierHeader.RECEIVER_COUNTRY || resetStates.receiverCountry,
      receiverPincode: courierHeader.RECEIVER_PINCODE || resetStates.receiverPincode,
      receiverPhone: courierHeader.RECEIVER_CONTACTNO || resetStates.receiverPhone,
      receiverEmail: courierHeader.RECEIVER_EMAILID || resetStates.receiverEmail,
      pickUpType: courierHeader.COLLECTION || resetStates.pickUpType,
      // eslint-disable-next-line no-unneeded-ternary
      acceptTerms: (Number(courierHeader.TERMS_ID) === 2 ? true : false),
      dimensionType: courierHeader.DimensionType || resetStates.dimensionType,
      senderAlterPhone: courierHeader.SENDER_ALTERCONTACTNO || resetStates.senderAlterPhone,
      receiverAlterPhone: courierHeader.RECEIVER_ALTERCONTACTNO || resetStates.receiverAlterPhone,
      // ID card and additional fields
      idCardType: courierHeader.SENDER_IDCARD_TYPE || resetStates.idCardType,
      IdCardNo: courierHeader.SENDER_IDCARD_NO || resetStates.IdCardNo,
      RecidCardType: courierHeader.RECEIVER_IDCARD_TYPE || resetStates.RecidCardType,
      RecIdCardNo: courierHeader.RECEIVER_IDCARD_NO || resetStates.RecIdCardNo,
      source: courierHeader.SOURCE || resetStates.source,
      shipper: courierHeader.ShipperLinerName || resetStates.shipper,
    };
    setInitialValue(updatedValues);

    // Set ID card images and shipper id for edit mode
    setBoxDetails(courierDetail);
    boxDetailsTempRef.current = JSON.parse(JSON.stringify(courierDetail));

    // Check for oversize and overweight conditions in retrieved data
    if (checkOversizeCondition(courierDetail)) {
      showOversizeWarning();
    }
    
    if (checkOverweightCondition(courierDetail)) {
      showOverweightWarning();
    }

    // Initialize boxLoadEnabled for each box based on whether goods are already loaded
    const initialBoxLoadEnabled = {};
    courierDetail.forEach((box, index) => {
      // If box already has goods loaded, disable load button
      // If box has no goods or empty goods array, enable load button
      initialBoxLoadEnabled[index] = !box.goods || box.goods.length === 0;
    });
    setBoxLoadEnabled(initialBoxLoadEnabled);

    const buildImageUrl = (imgPath) => {
      if (!imgPath) return '';
      if (imgPath.startsWith('http') || imgPath.startsWith('//')) {
        return imgPath.includes('?') ? `${imgPath}&v=${Date.now()}` : `${imgPath}?v=${Date.now()}`;
      }
      const origin = sessionStorage.getItem('Origin');
      const base = origin === 'IN' ? axios.defaults.inImageURL 
      : origin === 'UK' ? axios.defaults.ukImageURL : axios.defaults.slImageURL;
      const url = `${base}/${imgPath}`;
      return url.includes('?') ? `${url}&v=${Date.now()}` : `${url}?v=${Date.now()}`;
    };
    const senderImg = `MT${courierHeader.SENDER_IDCARD_NO}-${getIdCardNameById(courierHeader.SENDER_IDCARD_TYPE)}.jpg`;
    const receiverImg = `BMT${courierHeader.RECEIVER_IDCARD_NO}-${getIdCardNameById(courierHeader.RECEIVER_IDCARD_TYPE)}.jpg`;

    setSenderImagePreview(buildImageUrl(senderImg));
    setReceiverImagePreview(buildImageUrl(receiverImg));

    // Keep raw file/path in state so it can be submitted if needed
    setSenderImageFile(senderImg || null);
    setReceiverImageFile(receiverImg || null);
    setShipperId(courierHeader.SHIPPER_LINER_ID || 0);

    GetShipperPrice(courierDetail, courierHeader.RECEIVER_COUNTRY, courierHeader.DOC_TYPE);
  } catch (e) {
    openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
  }
  hideLoading();
}

  const getIdCardNameById =  (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => Number(card.id) === Number(id));

    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getSenderState = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setSenderStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setSenderStateList([])
    }
  };

  const getReceiverState = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setReceiverStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setReceiverStateList([])
    }
  };


  const getCountryName = (countryid) => {
    const countryObj = countryList.find((obj) => obj.CountryId === countryid);
    if (countryObj) {
      return countryObj.CountryName;
    } else {
      return null;
    }
  };

  const GetGoodsList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetGoodsHelp');
      setGoodsList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetUOMList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetUOMHelp');
      setUOMList(res.data);
      // const result = await axios.get('/Transactions/Courier/GetDefaultUOMHelp');
      // setDefaultUOMList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetTermsAndCondition() {
    try {
      showLoading();
      const response = await axios.get('signup/GetTermsAndCondition/11');
      setTermsConditions(response.data);
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const GetParameter = async () => {
    try {
      const res = await axios.get(`/master/parameter/GetParameters/${sessionStorage.getItem('CompanyId')}`);
      const hide = res.data[0].IsUOMHidden_Web === 'N' 
      setHideUom(hide);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    GetCountryList();
    GetBranchList(sessionStorage.getItem('Origin'));
    GetTermsAndCondition();
    GetGoodsList();
    GetUOMList();
    GetParameter();
    GetReceiverList()
  }, []);

  useLayoutEffect(() => {
    if (Type === 'Edit') {
      GetEditData(EditId);
      setIsLoadVisible(false);
    }
  }, [Type, EditId]);

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          // Initial data validation
          // shipMentType: Yup.string().required('Select Type of Shipment'),
          docType: Yup.string().required('Select Type of Document'),
          NofoBoxes: Yup.number()
            .required('No of boxes is required')
            .min(1, 'Must be at least 1 box')
            .max(10, 'No more than 10 boxes allowed'),
          senderCountry: Yup.string().required('Country is required'),
          receiverCountry: Yup.string().required('Country is required'),

          // Sender details validation
          ...(bookingStarted && {
            branch: Yup.string().required('Branch is required'),
            senderName: Yup.string().required('Sender name is required'),
            senderAddr1: Yup.string().required('Address line 1 is required'),
            senderAddr2: Yup.string(),
            senderAddr3: Yup.string(),
            senderCity: Yup.string().required('City is required'),
            senderPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            senderPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            senderEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Receiver details validation
            receiverName: Yup.string().required('Receiver name is required'),
            receiverAddr1: Yup.string().required('Address line 1 is required'),
            receiverAddr2: Yup.string(),
            receiverAddr3: Yup.string(),
            receiverCity: Yup.string().required('City is required'),
            receiverPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            receiverPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            // receiverEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Collection details validation
            // pickUpType: Yup.string().required('Pick-up type is required'),
           IdCardNo: Yup.string().when('idCardType', {
  is: (val) => val && val !== '0',
  then: (schema) =>
    schema
      .required('ID Card Number is required')
       .test(
        'not-all-zeros',
        'ID Card Number is required',
        (value) => {
          if (!value) return true; // Let required validation handle empty values
          return !/^0+$/.test(value); // Rejects strings that contain only zeros
        }
      ),
      // .min(3, 'ID Card Number must be at least 3 characters'),
  otherwise: (schema) => schema.notRequired(),
}),
RecIdCardNo: Yup.string().when('RecidCardType', {
  is: (val) => val && val !== '0',
  then: (schema) =>
    schema
      .required('ID Card Number is required')
      .test(
        'not-all-zeros',
        'ID Card Number is required',
        (value) => {
          if (!value) return true; // Let required validation handle empty values
          return !/^0+$/.test(value); // Rejects strings that contain only zeros
        }
      ),
      // .min(3, 'ID Card Number must be at least 3 characters'),
  otherwise: (schema) => schema.notRequired(),
}),

            acceptTerms: Yup.boolean()
              .oneOf([true], 'You must agree to the terms and conditions')
              .required('You must agree to the terms'),
            senderAlterPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
            receiverAlterPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
          }),
        })
      ),
    [bookingStarted, sessionStorage.getItem('Origin'), initialValue]
  );

  async function submitCourierOrder(values,isDraft) {
    const mergedData = buildCourierPayload(values, isDraft, boxDetails);
    const formData = convertToFormData(mergedData);
    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      saveInProgressRef.current = true;
      showLoading();
      const response = await axios.post('Transactions/Courier/InsertCourierHdr', formData, config);
      // await sendloginMail(values.mailid, values.fullName);
      setOpen(false);
      if (Type === 'Edit') {
        if(isDraft === 'Y'){
          openSnackBar('Draft has been  updated successfully!', 'success');
        } else {
          openSnackBar('Order has been updated successfully!', 'success');
          if (hasNewEntry(boxDetailsTempRef.current, boxDetails)) sendloginForOrderUpdated(sessionStorage.getItem('UserId'), response.data.courierId);
        }
      } else if (Type !== 'Edit') {
         if (isDraft === 'Y') {
          openSnackBar('Draft has been saved successfully!', 'success');
        } else {
          openSnackBar('Order has been created successfully!', 'success');
          sendloginForOrderPlaced(sessionStorage.getItem('UserId'), response.data.courierId);
        }
      }
      navigate('/dashboard/manage/booking');
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    } finally {
      saveInProgressRef.current = false;
    }
    hideLoading();
  }

  const handleOpenDialogPreview = (target) => {
    setPreviewTarget(target);
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
    setPreviewTarget(null);
  };

    const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };
  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  async function sendloginForOrderPlaced(cusID, OrderId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'OrderPlaced',
        customerid: cusID,
        Type: 'CO',
        Order_Id: OrderId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderUpdated(cusID, OrderId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'OrderUpdated',
        customerid: cusID,
        Type: 'CO',
        Order_Id: OrderId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  /*  In this If any changes in the detail it will return true */

  // const hasNewEntry = (prevData, newData) => {
  //   if (!prevData || !newData) return false; // Safety check for null/undefined data

  //   // Check if a new box was added
  //   if (newData.length !== prevData.length) {
  //     return true;
  //   }

  //   // Check if a new goods item was added inside any box
  //   return newData.some((newBox, index) => {
  //     const prevBox = prevData[index];

  //     if (!prevBox) return true; // New box detected

  //     console.log(`Box ${index + 1}: newBox goods count =`, newBox.goods?.length || 0);
  //     console.log(`Box ${index + 1}: prevBox goods count =`, prevBox.goods?.length || 0);

  //     return (newBox.goods?.length || 0) !== (prevBox.goods?.length || 0);
  //   });
  // };


  /*  In this If any New goods added in the detail it will return true */

  const hasNewEntry = (prevData, newData) => {
    if (!prevData || !newData) return false; // Safety check for null/undefined data

    // Check if a new box was added
    if (newData.length !== prevData.length) {
      return true;
    }

    // Check if a new goods item was added inside any box or if any goods has newGoods === 'Y'
    return newData.some((newBox, index) => {
      const prevBox = prevData[index];

      if (!prevBox) return true; // New box detected

      // Check if number of goods changed
      if ((newBox.goods?.length || 0) !== (prevBox.goods?.length || 0)) {
        return true;
      }

      // Check if any goods has newGoods === 'Y'
      return newBox.goods?.some(good => good.newGoods === 'Y');
    });
  };



  async function sendloginForBookingCancelledByCustomer(cusID, OrderId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'BookingCancelledByCustomer',
        customerid: cusID,
        Type: 'CO',
        Order_Id: OrderId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }


  const handleCountryChangeSender = (selectedCountry, handleChange) => {
    const selectedSenderCountryId = selectedCountry.CountryId;
    getSenderState(selectedSenderCountryId);
    handleChange({
      target: {
        name: 'senderCountry',
        value: selectedSenderCountryId,
      },
    });
  };

  const handleCountryChangereceiver = (selectedCountry, handleChange) => {
    const selectedCountryId = selectedCountry.CountryId;
    getReceiverState(selectedCountryId);
    handleChange({
      target: {
        name: 'receiverCountry',
        value: selectedCountryId,
      },
    });
  };

  const handleFileChange = (event, boxIndex, goodsIndex) => {
    // showLoading();
    if (boxIndex === undefined || goodsIndex === undefined) {
      console.error('Invalid indices: boxIndex or goodsIndex is undefined.');
      return;
    }

    const file = event.target.files[0];
    if (!file) {
      console.error('No file selected.');
      return;
    }

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Generate the preview URL for the image
    const imagePreviewUrl = URL.createObjectURL(file);

    // Update the preview URL in the separate state
    setImagePreviews((prev) => ({
      ...prev,
      [`${boxIndex}-${goodsIndex}`]: imagePreviewUrl,
    }));

    setBoxDetails((prevBoxDetails) => {
      const updatedBoxDetails = [...prevBoxDetails];
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        image: file, // Keep the file object
      };
      return updatedBoxDetails;
    });
    // hideLoading();
  };

  const handleIdFileChange = (event, target) => {
    const file = event.target.files[0];
    if (!file) return;

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and preview depending on whether it's sender or receiver
    if (target === 'sender') {
      setSenderImageFile(file);
      setSenderImagePreview(URL.createObjectURL(file));
    } else if (target === 'receiver') {
      setReceiverImageFile(file);
      setReceiverImagePreview(URL.createObjectURL(file));
    } else {
      // fallback: keep old single-file behavior
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const toggleAccordion = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const toggleAccordionTrue = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: true }));
  };

const handleBoxCountChange = (value) => {
  showLoading();
  setBoxCount(value);
  
  const uom = uomList.find(i => i.DefaultUOM === 'Y') || { UOM_Id: 0, UOM_Description: '' };
  
  const boxes = Array.from({ length: value }, (_, index) => ({
    boxNo: index + 1,
    length: '',
    width: '',
    height: '',
    cubicWeight: '',
    grossWeight: '',
    noOfItems: 1, // Start with 1 item
    goods: [
      {
        goodsName: '',
        uom: '',
        UOM_Id: uom.UOM_Id,
        UOM_Description: uom.UOM_Description,
        quantity: '',
        rate: '',
        value: '',
        newGoods: 'N',
        image: null,
        GoodsId: '0',
      }
    ], // Load one default good automatically
  }));
  
  setBoxDetails(boxes);
  
  // Initialize boxLoadEnabled for all boxes (disable load since goods are already loaded)
  const initialLoadState = {};
  for (let i = 0; i < value; i++) {
    initialLoadState[i] = true; // Disable load for all boxes
  }
  setBoxLoadEnabled(initialLoadState);
  toggleAccordion(0);
  
  hideLoading();
};
  // const handleAddBox = async (setFieldValue, values) => {
  //   // showLoading();
  //   setInitialValue(values);
  //   setBoxDetails((prevDetails) => {
  //     const updatedBoxes = [
  //       ...prevDetails,
  //       {
  //         boxNo: prevDetails.length + 1, // Ensure the boxNo is incremented correctly as a number
  //         length: '',
  //         width: '',
  //         height: '',
  //         // dimensionType: 'CM',
  //         cubicWeight: '',
  //         grossWeight: '',
  //         noOfItems: '',
  //         goods: [],
  //       },
  //     ];
  //     return updatedBoxes; // Update the box count state
  //   });
  //   setTimeout(async () => {
  //     await new Promise((resolve) => {
  //       setFieldValue('NofoBoxes', boxDetails.length + 1, () => resolve());
  //     });
  //   }, 1000);
  //   // hideLoading();
  // };
const handleAddBox = async (setFieldValue, values) => {
  // showLoading();
  setInitialValue(values);
   const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0;
  setBoxDetails((prevDetails) => {
    
    const newBoxIndex = prevDetails.length;
    const updatedBoxes = [
      ...prevDetails,
      {
        boxNo: prevDetails.length + 1,
        length: '',
        width: '',
        height: '',
        cubicWeight: '',
        grossWeight: '',
        noOfItems: 1,
        goods: [ {
            goodsName: '',
            uom: '',
            UOM_Id: uom.UOM_Id,
            UOM_Description: uom.UOM_Description,
            quantity: '',
            rate: '',
            value: '',
            newGoods: 'N',
            image: null,
            GoodsId: '0',
          }],
      },
    ];
  
    // Enable load for the new box
    setBoxLoadEnabled(prev => ({
      ...prev,
      [newBoxIndex]: true
    }));
         toggleAccordion(newBoxIndex);

    // Check for oversize and overweight conditions after adding the box
    const newBox = updatedBoxes[newBoxIndex];
    if (newBox.length >= 100 || newBox.width >= 100 || newBox.height >= 100) {
      showOversizeWarning();
    }

    if (newBox.grossWeight >= 31) {
      showOverweightWarning();
    }

    return updatedBoxes;
  });
  
  setTimeout(async () => {
    await new Promise((resolve) => {
      setFieldValue('NofoBoxes', boxDetails.length + 1, () => resolve());
    });
  }, 1000);
  // hideLoading();
};

  const handleAddGoods = (boxIndex, newFlag) => {
    showLoading();
    const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.push({
      goodsName: '',
      uom: '',
      UOM_Id: uom.UOM_Id,
      UOM_Description: uom.UOM_Description,
      quantity: '',
      rate: '',
      value: '',
      newGoods: newFlag,
      image: null,
      GoodsId: '0',
    });
    setBoxDetails(updatedBoxDetails);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    hideLoading();
  };

  const handleDeleteGoods = (boxIndex, goodsIndex) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.splice(goodsIndex, 1);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;

    setBoxDetails(updatedBoxDetails);
    setImagePreviews((prevPreviews) => {
      const imgPreviews = { ...prevPreviews };
      delete imgPreviews[`${boxIndex}-${goodsIndex}`];
      const updatedPreviews = Object.fromEntries(
        Object.entries(imgPreviews).map(([key, val], i) => {
          const newKey = key.split('-').map(Number);
          if (newKey[1] >= goodsIndex) newKey[1] -= 1;
          return [newKey.join('-'), val];
        })
      );
      return updatedPreviews;
    });
  };

  const handleGoodsChange = (boxIndex, goodsIndex, field, value) => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];
    if (field === 'goods') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        GoodsName: value.GoodsName,
        GoodsId: value.GoodsId,
      };
    } else if (field === 'uom') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        UOM_Description: value.UOM_Description,
        UOM_Id: value.UOM_Id,
      };
    } else {
      updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    }

    // Recalculate the total value of the goods in the box
    if (field === 'quantity' || field === 'rate') {
      const updatedGoods = updatedBoxDetails[boxIndex].goods[goodsIndex];
      updatedGoods.value = parseFloat((updatedGoods.quantity * updatedGoods.rate).toFixed(2))
    }
    setBoxDetails(updatedBoxDetails);
    hideLoading();
  };

  const handleGoodsChangeY = (boxIndex, goodsIndex, field, value) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    setBoxDetails(updatedBoxDetails);
  };

  const getTotalValue = (boxIndex) => {
    const box = boxDetails[boxIndex];
    return parseFloat(
      box.goods.reduce((total, goods) => Number(total) + Number(goods.value), 0).toFixed(2)
    );
  };

  const resetBooking = () => {
    showLoading();
    setInitialValue(resetStates);
    setBoxCount(0);
    setBoxDetails([]);
    setImagePreviews({});
    setSelectedImageFile('');
    setSenderImageFile(null);
    setReceiverImageFile(null);
    setSenderImagePreview('');
    setReceiverImagePreview('');
    setBookingStarted(false);
    hideLoading();
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setBoxToDelete(boxIndex); // Set the box to be deleted
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close the confirmation dialog
    setBoxToDelete(null);
  };

  const handleCloseConfirmDialog1 = () => {
    setOpenConfirmDialog1(false); // Close the confirmation dialog
    if (Type !== 'Edit') setsameAsSender(false);
  };

  const handleSamesAsAddress = async (e, setFieldValue, values) => {
    const isChecked = e.target.checked;
    setsameAsSender(isChecked);
    if (isChecked) {
      try {
        // if (!20629) return;
        const res = await axios.get(`/Transactions/Courier/GetSameAsAddress/${sessionStorage.getItem('UserId')}`);
        const {data} = res;
        data.forEach(async (senderData) => {
          let state = {};
          if (senderData.CusCountryId && senderData.CusCountryId !== 0) {
            try {
              getSenderState(senderData.CusCountryId);
              const res = await axios.get(`/signup/GetAllState/${senderData.CusCountryId}`);
              state = res.data.find((d) => Number(d.StateId) === Number(senderData.CusstateId));
            } catch {
              console.log('error');
            }
          }
          setSenderSecondaryCountryId(Number(senderData.CusCountryId))
          if (Number(values.senderCountry) === Number(senderData.CusCountryId)) {
            setsenderCountryErr(false);
            setFieldValue('senderName', senderData.CustomerName || '');
            setFieldValue('senderAddr1', senderData.Address1 || '');
            setFieldValue('senderAddr2', senderData.Address2 || '');
            setFieldValue('senderAddr3', senderData.Address3 || '');
            setFieldValue('senderCity', senderData.City || '');
            setFieldValue('senderState', state ? state.StateId : '');
            // setFieldValue('senderCountry', senderData.CusCountryId || '');
            setFieldValue('senderPincode', senderData.Zipcode || '');
            setFieldValue('senderPhone', senderData.Phone || '');
            setFieldValue('senderEmail', senderData.EmailId || '');
            setFieldValue('senderAlterPhone', senderData.AlterPhone || '');
          } else {
            setOpenConfirmDialog1(true);
            const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
            const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderData.CusCountryId));
            setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
            and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
          }
        });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      setSenderSecondaryCountryId(Number(values.senderCountry))
      // If unchecked, reset the sender data fields
      setFieldValue('senderName', '');
      setFieldValue('senderAddr1', '');
      setFieldValue('senderAddr2', '');
      setFieldValue('senderAddr3', '');
      setFieldValue('senderCity', '');
      setFieldValue('senderState', '');
      // setFieldValue('senderCountry', '');
      setFieldValue('senderPincode', '');
      setFieldValue('senderPhone', '');
      setFieldValue('senderEmail', '');
      setFieldValue('senderAlterPhone', '');
    }
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [prevImage, setPrevImage] = useState({});

  const handleDeleteImage = () => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];

    // Reset the image for the specific goods item
    updatedBoxDetails[prevImage.index].goods[prevImage.goodsIndex] = {
      ...updatedBoxDetails[prevImage.index].goods[prevImage.goodsIndex],
      image: null, // Reset image to null
    };

    // Update the state for boxDetails
    setBoxDetails(updatedBoxDetails);

    // Remove the preview URL for the specific goods item
    setImagePreviews((prevPreviews) => {
      const updatedPreviews = { ...prevPreviews };
      delete updatedPreviews[`${prevImage.index}-${prevImage.goodsIndex}`]; // Remove preview for the deleted image
      return updatedPreviews;
    });

    // Update only the image property in prevImage
    setPrevImage((prev) => ({
      ...prev,
      goods: {
        ...prev.goods,
        image: null, // Reset the image to null
      },
    }));
    hideLoading();
  };

  const handleOpenDialog = (index, goodsIndex, goods) => {
    setDialogOpen(true);
    setSelectedGoods({
      index,
      goodsIndex,
      goods,
    });
    setPrevImage({
      index,
      goodsIndex,
      goods,
    });
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setPrevImage({});
    setSelectedGoods(null);
  };

  const validateBoxDetails = (box, boxIndex) => {
    const errors = [];

    if (box.length === '' || Number(box.length) === 0) {
      errors.push(`Row ${boxIndex + 1}: Length is required.`);
    }

    if (box.width === '' || Number(box.width) === 0) {
      errors.push(`Row ${boxIndex + 1}: Width is required.`);
    }

    if (box.height === '' || Number(box.height) === 0) {
      errors.push(`Row ${boxIndex + 1}: Height is required.`);
    }

    if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
      errors.push(`Row ${boxIndex + 1}: Gross Weight is required.`);
    }

    if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
      errors.push(`Row ${boxIndex + 1}: No of Items is required.`);
    }

    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Validation failed for this row
    }

    return true; // All validations passed
  };

  const validateBoxGoodsDetails = (boxDetails) => {
    // Validate boxDetails
    const errors = [];

    boxDetails.forEach((box, boxIndex) => {
      if (box.length === '' || Number(box.length) === 0) {
        errors.push(`Box ${boxIndex + 1}: Length is required.`);
      }

      if (box.width === '' || Number(box.width) === 0) {
        errors.push(`Box ${boxIndex + 1}: Width is required.`);
      }

      if (box.height === '' || Number(box.height) === 0) {
        errors.push(`Box ${boxIndex + 1}: Height is required.`);
      }

      if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
        errors.push(`Box ${boxIndex + 1}: Gross Weight is required.`);
      }

      if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
        errors.push(`Box ${boxIndex + 1}: No of Items is required.`);
      }

      // Validate goods within the box
      if (!box.goods || box.goods.length === 0) {
        errors.push(`Box ${boxIndex + 1}: Enter goods details.`);
      } else {
        // Validate goods within the box
        box.goods.forEach((good, goodIndex) => {
          const goodsNameExists = 'GoodsName' in good;
          const goodsIdExists = 'GoodsId' in good;
          if (
            good.newGoods === 'Y'
              ? good.goodsName === ''
              : (goodsNameExists ? good.GoodsName === '' : false) || !goodsIdExists || Number(good.GoodsId) === 0
          ) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Goods Name is required.`);
          }

          if (good.quantity === '' || Number(good.quantity) === 0) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Quantity is required.`);
          }
        });
      }
    });

    // Show errors if any
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Stop the process if validation fails
    }

    return true; // All validations passed
  };

  const GetShipperPrice = async (data, receiverCountryids, docType) => {
    const result = data.reduce(
      (acc, item) => {
        const ceilingCubicWeight = Math.ceil(item.cubicWeight || 0);
        const ceilingGrossWeight = Math.ceil(item.grossWeight || 0);
        const higherWeight = Math.max(ceilingCubicWeight, ceilingGrossWeight);
        acc.totalWeight += higherWeight;
        return acc;
      },
      { totalWeight: 0 }
    );
    try {
      const res = await axios.get(
        `/Transactions/Courier/GetAllCourierShipperPrice/${sessionStorage.getItem(
          'CompanyId'
        )}/${sessionStorage.getItem('BranchId')}/${receiverCountryids || receiverCountryId}/${result.totalWeight}/${docType || documentType}`,
        configuration
      );
      if (res.data.length > 0) {
        setShipperPriceData(res.data);
        setCardToggle(true);
      } else {
        setShipperPriceData([]);
        setCardToggle(false);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  // useEffect(() => {
  //   GetShipperPrice();
  // }, [boxDetails]);

  const startsWithFilter = createFilterOptions({
    matchFrom: 'any', // The Filter Type are start and any
    stringify: (option) => option.GoodsName || '', // Determines the field to filter
  });

  const GetReceiverList = async () => {
    try {
      const config = {
        headers: {
          Country: sessionStorage.getItem('Origin'),
        },
      };
      const response = await axios.post(`/Transactions/Courier/GetAllCourierReceiverHelp`, {
        CustomerId: sessionStorage.getItem('UserId')
      }, sessionStorage.getItem('CompanyId'), config);
      setReceiverList(response.data);
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }}>
        {/* table header */}
        <Typography
          variant="h5"
          p={1}
          boxShadow={1}
          borderColor="#11235A"
          textAlign={'center'}
          borderRadius={8}
          color="white"
          sx={{
            background: ' linear-gradient(to right, #000428, #004e92)',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
          }}
        >
          <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
            {Status === 'A' ? `Courier Order Review - Order No ${EditId}` : 'Courier Order Creation'}
          </Typography>
        </Typography>

        {orderCancel === 'Y' &&
          <Chip
            label={`Your order has been successfully cancelled. Reason: ${cancelRemarksText}`}
            size="small"
            color="warning"
            variant="contained"
            icon={<ReportGmailerrorredIcon />}
            sx={{ mb: 2, mt: 2, width: '100%' }}
          />
        }

        <Container component={Paper} elevation={2}>
          <Divider sx={{ my: 2 }} variant="middle">
            <Chip label="Basic Details" size="small" color="primary" variant="outlined" />
          </Divider>
          <Formik
            innerRef={formikRef}
            enableReinitialize={Type === 'Edit'}
            validationSchema={ValidationSchema}
            initialValues={{ ...initialValue, boxDetails, senderSecondaryCountryId }}
            onSubmit={async (values, { resetForm, setErrors, setFieldError }) => {
              await submitCourierOrder({ ...initialValue, ...values },'N');
              resetForm();
            }}
          >
            {({
              submitForm,
              touched,
              values,
              errors,
              handleChange,
              handleBlur,
              isSubmitting,
              setFieldTouched,
              validateForm,
              setFieldValue,
              resetForm,
              setErrors,
              setTouched,
            }) => {
              latestValuesRef.current = { ...initialValue, ...values };
              return (
                <Form>
                <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                  <Grid item md={Type === 'Edit' ? 6 : 12} xs={12}>
                    <FormControl fullWidth size="small" required>
                      <InputLabel>Shipment Type</InputLabel>
                      <Select
                        value={ShipType || values.shipMentType}
                        name="shipMentType"
                        size="small"
                        label="Shipment Type"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.shipMentType && !!errors.shipMentType}
                        disabled
                        required
                      >
                        {sessionStorage.getItem('Origin') === 'IN'
                          ? shipMentTypesforIN.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))
                          : sessionStorage.getItem('Origin') === 'UK'
                          ? shipMentTypesforUK.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>))
                          : shipMentTypesforSL.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </Select>
                      {touched.shipMentType && errors.shipMentType && (
                        <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                          {errors.shipMentType}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                    {/* <Grid item md={3} xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Source</InputLabel>
                      <Select
                        value={values.source || ''}
                        name="source"
                        size="small"
                        label="Source"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="Export">Export</MenuItem>
                         <MenuItem value="Import">Import</MenuItem>
                      </Select> 
                      {touched.source && errors.source && (
                        <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                          {errors.source}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid> */}
                {Type === 'Edit' && <Grid item md={6} xs={12}>
                    <FormControl fullWidth size="small">
                      <TextField
                        fullWidth
                        size="small"
                        label="Shipper"
                        name="shipper"
                        value={values.shipper || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                      />
                    </FormControl>
                  </Grid> }
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth size="small" required>
                      <Autocomplete
                        options={countryList || []}
                        getOptionLabel={(country) => country.CountryName || ''}
                        renderOption={(props, country) => (
                          <li {...props} key={country.CountryId}>
                            {country.CountryName}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                        value={countryList.find((country) => country.CountryId === values.senderCountry) || null}
                        name="senderCountry"
                        onChange={(event, value) => {
                          if (value) {
                            setsenderCountryErr(false);
                            setFieldValue('senderCountry', value.CountryId);
                            handleCountryChangeSender(value, handleChange);
                          } else {
                            setFieldValue('senderCountry', '');
                          }
                        }}
                        onBlur={() => setFieldTouched('senderCountry', true)}
                        size="small"
                        disabled={isDisabled}
                        required
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Sender Country"
                            value={values.senderCountry ? values.senderCountry : ''}
                            // error={touched.senderCountry && !!errors.senderCountry}
                            // helperText={touched.senderCountry && errors.senderCountry}
                            helperText={senderCountryErr ? 'Sender Country is required' : ''}
                            FormHelperTextProps={{
                              style: { color: 'red' },
                            }}
                          />
                        )}
                        noOptionsText="No country available"
                      />
                    </FormControl>
                  </Grid>
                
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth size="small" required>
                      <Autocomplete
                        options={countryList || []} // Options for the Autocomplete
                        getOptionLabel={(country) => country.CountryName || ''} // Display country name
                        renderOption={(props, country) => (
                          <li {...props} key={country.CountryId}>
                            {country.CountryName}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                        value={countryList.find((country) => country.CountryId === values.receiverCountry) || null}
                        name="receiverCountry"
                        onChange={(event, value) => {
                          if (value) {
                            setreceiverCountryErr(false);
                            setFieldValue('receiverCountry', value.CountryId);
                            setReceiverCountryId(value.CountryId);
                            handleCountryChangereceiver(value, handleChange);
                            GetShipperPrice(boxDetails);
                          } else {
                            setFieldValue('receiverCountry', '');
                          }
                        }}
                        onBlur={() => setFieldTouched('receiverCountry', true)}
                        size="small"
                        disabled={isDisabled}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Receiver Country"
                            value={values.receiverCountry ? values.receiverCountry : ''}
                            // error={touched.receiverCountry && !!errors.receiverCountry}
                            // helperText={touched.receiverCountry && errors.receiverCountry}
                            helperText={receiverCountryErr ? 'Receiver Country is required' : ''}
                            FormHelperTextProps={{
                              style: { color: 'red' },
                            }}
                          />
                        )}
                        noOptionsText="No country available"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={2} xs={12}>
                    <FormControl fullWidth size="small" required>
                      <InputLabel>Document Type</InputLabel>
                      <Select
                        value={values.docType || ''}
                        name="docType"
                        size="small"
                        label="Document Type"
                        // onChange={handleChange}
                        onChange={async (event) => {
                          handleChange(event);
                          const data = event.target.value
                          setDocumentType(data)
                          setInitialValue(() => ({ ...values, docType: data }))
                          GetShipperPrice(boxDetails, values.receiverCountry, data);
                        }}
                        onBlur={handleBlur}
                        error={touched.docType && !!errors.docType}
                        disabled={isDisabled}
                        required
                      >
                        {DocTypes.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.docType && errors.docType && (
                        <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                          {errors.docType}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item md={Type === 'Edit' || !bookingStarted ? 2 : 1} xs={12}>
                    <FormControl fullWidth size="small" required>
                      <InputLabel>Dimension</InputLabel>
                      <Select
                        value={values.dimensionType || ''}
                        name="dimensionType"
                        size="small"
                        label="Dimension Type"
                        onChange={async (event) => {
                          handleChange(event);
                          const data = event.target.value
                          setInitialValue(() => ({ ...values, dimensionType: data }))

                          if (boxDetails.length > 0) {
                            const updatedBoxes = boxDetails.map((box) => {
                              const rawCubicWeight =
                                data === 'CM'
                                  ? (box.height * box.width * box.length) / 5000
                                  : (box.height * box.width * box.length) / 1925;

                              return {
                                ...box,
                                cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
                              };
                            });
                            setBoxDetails(updatedBoxes);
                            GetShipperPrice(updatedBoxes);
                          }
                        }}
                        onBlur={handleBlur}
                        error={touched.dimensionType && !!errors.dimensionType}
                        disabled={isDisabled}
                        required
                      >
                        {DimensionType.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.dimensionType && errors.dimensionType && (
                        <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                          {errors.dimensionType}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                { Type === 'Edit' &&  <Grid item md={2} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="No of Boxes"
                      type="text"
                      name="NofoBoxes"
                      // disabled={isDisabled || bookingStarted}
                      disabled
                      onBlur={handleBlur}
                      error={touched.NofoBoxes && !!errors.NofoBoxes}
                      helperText={touched.NofoBoxes && errors.NofoBoxes ? errors.NofoBoxes : ''}
                      value={values.NofoBoxes}
                      required
                      onChange={(e) => {
                        handleChange(e);
                        const noOfBoxes = parseInt(e.target.value, 10);

                        // Dynamically update the lengths in boxDetails if valid input
                        if (!Number.isNaN(Number(noOfBoxes)) && noOfBoxes > 0) {
                          const updatedBoxDetails = values.boxDetails.map((box, index) => ({
                            ...box,
                            length: noOfBoxes + index, // Example logic: Update length dynamically
                          }));

                          // Update Formik's state
                          setFieldValue('boxDetails', updatedBoxDetails);
                        }
                      }}
                    />
                  </Grid> }

                  {Type !== 'Edit' && (
                    <Grid item md={bookingStarted ? 1 : 12} xs={12}>
                      <Stack direction="row" justifyContent="center" sx={{ width: '100%' }}>
                        <Button
                          variant={bookingStarted ? 'outlined' : 'contained'}
                          color={bookingStarted ? 'error' : 'warning'}
                          size={bookingStarted ? 'medium' : 'small'}
                          sx={{ boxShadow: 1 }}
                          type={bookingStarted ? 'button' : 'submit'}
                          onClick={async () => {
                           if (bookingStarted) {
          setResetOpenDialog(true);                             
        } else {
          const formErrors = await validateForm();
          if (Object.keys(formErrors).length === 0) {
            handleBoxCountChange(values.NofoBoxes);
            setBookingStarted(true);
            
            // Auto-load goods with noOfItems=1 and one good pre-loaded
            // The handleBoxCountChange already does this
            
            // Expand the first box after state updates
            // setTimeout(() => {
            //   toggleAccordion(0);
            // }, 100);
          }
        }
                          }}
                          fullWidth={bookingStarted}
                          disabled={isDisabled}
                        >
                          {bookingStarted ? 'Reset' : 'Start Booking'}
                        </Button>
                      </Stack>
                    </Grid>
                  )}
                  {bookingStarted && (<>
                      <Grid item md={12} xs={12}>
                        <Divider sx={{ mt: 2 }} variant="middle">
                          <Chip label="Shipment Details" size="small" color="info" variant="outlined" />
                        </Divider>
                      </Grid>
                        <Grid item md={12} xs={12}>
                                              <Grid container  spacing={2} rowSpacing={4} columnSpacing={4}  pl={2} >
                                                <Grid item xs={12}>
                                                  <Stack
                                                    direction="column"
                                                    alignItems="right"
                                                    justifyContent="right"
                                                    spacing={1}
                                                    sx={{ p: 0, m: 0 }}
                                                  >
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          disabled={isDisabled}
                                                          checked={sameAsSender}
                                                          onChange={(event) => {
                                                            handleSamesAsAddress(event, setFieldValue, values);
                                                          }}
                                                          name="sameAsAddress"
                                                          color="primary"
                                                          size="small"
                                                        />
                                                      }
                                                      label="Same as Customer"
                                                    />
                                                  </Stack>
                                                </Grid>
                      
                                                {/* Sender Details */}
                                                <Grid item md={6} xs={12}>
                                                  <Grid
                                                    container
                                                    spacing={2}
                                                    rowSpacing={2}
                                                    columnSpacing={2}
                                                    component={Paper}
                                                    p={2}
                                                    pt={0}
                                                    pl={0}
                                                    pr={2}
                                                    
                                                    elevation={3}
                                                    sx={{
                                                      bgcolor: 'inherit',
                                                      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                                    }}
                                                  >
                                                    <Grid item md={12} xs={12}>
                                                      <Divider sx={{ mb: 0 }} variant="fullWidth">
                                                        <Chip label="Sender Details" size="small" variant="outlined" />
                                                      </Divider>
                                                    </Grid>
                      
                                                    <Grid item md={12} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Name"
                                                        type="text"
                                                        name="senderName"
                                                        inputRef={el => { fieldRefs.current.senderName = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderName && !!errors.senderName}
                                                        helperText={touched.senderName && errors.senderName ? errors.senderName : ''}
                                                        value={values.senderName}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                        required
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Contact No"
                                                        type="text"
                                                        name="senderPhone"
                                                        inputRef={el => { fieldRefs.current.senderPhone = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderPhone && !!errors.senderPhone}
                                                        helperText={touched.senderPhone && errors.senderPhone ? errors.senderPhone : ''}
                                                        value={values.senderPhone}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                          handleChange({ target: { name: 'senderPhone', value: numericValue } });
                                                        }}
                                                        required
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Alternative Contact No"
                                                        type="text"
                                                        name="senderAlterPhone"
                                                        onBlur={handleBlur}
                                                        error={touched.senderAlterPhone && !!errors.senderAlterPhone}
                                                        helperText={touched.senderAlterPhone && errors.senderAlterPhone ? errors.senderAlterPhone : ''}
                                                        value={values.senderAlterPhone}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                          handleChange({ target: { name: 'senderAlterPhone', value: numericValue } });
                                                        }}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={12} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Email"
                                                        type="email"
                                                        name="senderEmail"
                                                        inputRef={el => { fieldRefs.current.senderEmail = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderEmail && !!errors.senderEmail}
                                                        helperText={touched.senderEmail && errors.senderEmail ? errors.senderEmail : ''}
                                                        value={values.senderEmail}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                        required
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 1"
                                                        name="senderAddr1"
                                                        inputRef={el => { fieldRefs.current.senderAddr1 = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderAddr1 && !!errors.senderAddr1}
                                                        helperText={touched.senderAddr1 && errors.senderAddr1 ? errors.senderAddr1 : ''}
                                                        value={values.senderAddr1}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                        required
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 2"
                                                        name="senderAddr2"
                                                        onBlur={handleBlur}
                                                        error={touched.senderAddr2 && !!errors.senderAddr2}
                                                        helperText={touched.senderAddr2 && errors.senderAddr2 ? errors.senderAddr2 : ''}
                                                        value={values.senderAddr2}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 3"
                                                        name="senderAddr3"
                                                        onBlur={handleBlur}
                                                        error={touched.senderAddr3 && !!errors.senderAddr3}
                                                        helperText={touched.senderAddr3 && errors.senderAddr3 ? errors.senderAddr3 : ''}
                                                        value={values.senderAddr3}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <FormControl fullWidth size="small">
                                                        <Autocomplete
                                                          options={countryList || []}
                                                          getOptionLabel={(country) => country.CountryName || ''}
                                                          renderOption={(props, country) => (
                                                            <li {...props} key={country.CountryId}>
                                                              {country.CountryName}
                                                            </li>
                                                          )}
                                                          isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                                                          value={
                                                            countryList.find((country) => country.CountryId === values.senderCountry) || null
                                                          }
                                                          disabled
                                                          name="senderCountry"
                                                          onChange={(event, value) => {
                                                            if (value) {
                                                              setsenderCountryErr(false);
                                                              setFieldValue('senderCountry', value.CountryId);
                                                              handleCountryChangeSender(value, handleChange);
                                                            } else {
                                                              setFieldValue('senderCountry', '');
                                                            }
                                                          }}
                                                          onBlur={() => setFieldTouched('senderCountry', true)}
                                                          size="small"
                                                          renderInput={(params) => (
                                                            <TextField
                                                              required
                                                              {...params}
                                                              label="Sender Country"
                                                              value={values.senderCountry ? values.senderCountry : ''}
                                                              helperText={senderCountryErr ? 'Sender Country is required' : ''}
                                                              FormHelperTextProps={{
                                                                style: { color: 'red' },
                                                              }}
                                                            />
                                                          )}
                                                          noOptionsText="No country available"
                                                        />
                                                      </FormControl>
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <FormControl fullWidth size="small">
                                                        <Autocomplete
                                                          options={senderStateList || []}
                                                          getOptionLabel={(state) => state.StateName || ''}
                                                          renderOption={(props, state) => (
                                                            <li {...props} key={state.StateId}>
                                                              {state.StateName}
                                                            </li>
                                                          )}
                                                          isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                                          value={
                                                            senderStateList.find((state) => state.StateId === values.senderState) || null
                                                          }
                                                          disabled={isDisabled}
                                                          name="senderState"
                                                          onChange={(event, value) => {
                                                            if (value) {
                                                              setFieldValue('senderState', value.StateId);
                                                            } else {
                                                              setFieldValue('senderState', '');
                                                            }
                                                          }}
                                                          onBlur={() => setFieldTouched('senderState', true)}
                                                          size="small"
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              label="Sender Province/State"
                                                              value={values.senderState ? values.senderState : ''}
                                                              error={touched.senderState && !!errors.senderState}
                                                              helperText={touched.senderState && errors.senderState}
                                                            />
                                                          )}
                                                          noOptionsText="No Province/State available"
                                                        />
                                                      </FormControl>
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="City"
                                                        type="text"
                                                        required
                                                        name="senderCity"
                                                        inputRef={el => { fieldRefs.current.senderCity = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderCity && !!errors.senderCity}
                                                        helperText={touched.senderCity && errors.senderCity ? errors.senderCity : ''}
                                                        value={values.senderCity}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Postal Code"
                                                        type="text"
                                                        required
                                                        name="senderPincode"
                                                        inputRef={el => { fieldRefs.current.senderPincode = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.senderPincode && !!errors.senderPincode}
                                                        helperText={touched.senderPincode && errors.senderPincode ? errors.senderPincode : ''}
                                                        value={values.senderPincode}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                      
                                                {/* Receiver Details */}
                                                <Grid item md={6} xs={12}>
                                                  <Grid
                                                    container
                                                    spacing={2}
                                                    rowSpacing={2}
                                                    columnSpacing={2}
                                                    component={Paper}
                                                    p={2}
                                                    pt={0}
                                                    pl={0}
                                                    pr={2}
                                                    elevation={3}
                                                    sx={{
                                                      bgcolor: 'inherit',
                                                      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                                    }}
                                                  >
                                                    <Grid item md={12} xs={12}>
                                                      <Divider sx={{ mb: 0 }} variant="fullWidth">
                                                        <Chip label="Receiver Details" size="small" variant="outlined" />
                                                      </Divider>
                                                    </Grid>
                      
                                                    <Grid item md={12} xs={12}>
                                                      <FormControl fullWidth size="small">
                                                        <Autocomplete
                                                          options={receiverList || []}
                                                          getOptionLabel={(receiver) => {
                                                            if (!receiver) return '';
                                                            if (typeof receiver === 'string') return receiver;
                                                            return `${receiver.receiver_Name}`;
                                                          }}
                                                          filterOptions={(options, state) => {
                                                            const inputValue = state.inputValue.toLowerCase();
                                                            return options.filter(option =>
                                                              option.receiver_Name.toLowerCase().includes(inputValue) ||
                                                              (option.receiver_ContactNo && option.receiver_ContactNo.toString().toLowerCase().includes(inputValue))
                                                            );
                                                          }}
                                                          renderOption={(props, receiver) => (
                                                            <li {...props} key={receiver.receiver_Id}>
                                                              <div>
                                                                <strong>{receiver.receiver_Name}</strong>
                                                                <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                                                  {receiver.receiver_ContactNo}
                                                                </div>
                                                              </div>
                                                            </li>
                                                          )}
                                                          isOptionEqualToValue={(option, value) => {
                                                            if (!option || !value) return false;
                                                            if (typeof value === 'string') return option.receiver_Name === value;
                                                            return option.receiver_Id === value.receiver_Id;
                                                          }}
                                                          value={
                                                            values.receiverId
                                                              ? receiverList.find(r => r.receiver_Id === values.receiverId) || values.receiverName || null
                                                              : values.receiverName || null
                                                          }
                                                          name="receiverName"
                                                          onChange={(event, value) => {
                                                            if (value && typeof value === 'object') {
                                                              setFieldValue('receiverName', value.receiver_Name);
                                                              setFieldValue('receiverId', value.receiver_Id);
                                                              setFieldValue('receiverAddr1', value.receiver_Address1);
                                                              setFieldValue('receiverAddr2', value.receiver_Address2);
                                                              setFieldValue('receiverAddr3', value.receiver_Address3);
                                                              setFieldValue('receiverCity', value.receiver_City);
                                                              setFieldValue('receiverState', value.receiver_Stateid);
                                                              setFieldValue('receiverPincode', value.receiver_Pincode);
                                                              setFieldValue('receiverPhone', value.receiver_ContactNo);
                                                              setFieldValue('receiverAlterPhone', value.receiver_AlterContactNo);
                                                              setFieldValue('receiverEmail', value.receiver_EmailId);
                                                              setFieldValue('idCardType',value.Sender_Idcard_Type);
                                                              setFieldValue('IdCardNo',value.Sender_Idcard_No);
                                                              setFieldValue('RecidCardType',value.Receiver_Idcard_Type);
                                                              setFieldValue('RecIdCardNo',value.Receiver_Idcard_No);
                      
                                                                                      const buildImageUrl = (imgPath) => {
                                                                                      if (!imgPath) return '';
                                                                                      if (imgPath.startsWith('http') || imgPath.startsWith('//')) {
                                                                                        return imgPath.includes('?') ? `${imgPath}&v=${Date.now()}` : `${imgPath}?v=${Date.now()}`;
                                                                                      }
                                                                                      const origin = sessionStorage.getItem('Origin');
                                                                                      const base = origin === 'IN' ? axios.defaults.inImageURL 
                                                                                      : origin === 'UK' ? axios.defaults.ukImageURL : axios.defaults.slImageURL;
                                                                                      const url = `${base}/${imgPath}`;
                                                                                      return url.includes('?') ? `${url}&v=${Date.now()}` : `${url}?v=${Date.now()}`;
                                                                                    };
                      
                                                    const senderImg = `MT${value.Sender_Idcard_No}-${getIdCardNameById(value.Sender_Idcard_Type)}.jpg`;
                                                    const receiverImg = `BMT${value.Receiver_Idcard_No}-${getIdCardNameById(value.Receiver_Idcard_Type)}.jpg`;
                      
                                                    setSenderImagePreview(buildImageUrl(senderImg));
                                                    setReceiverImagePreview(buildImageUrl(receiverImg));
                                                    setSenderImageFile(senderImg || null);
                                                    setReceiverImageFile(receiverImg || null);
                                                    setSendPreviewBtn(true)
                                                    setReceivPreviewBtn(true)
                                                            } else {
                                                              setFieldValue('receiverName', value || '');
                                                              setFieldValue('receiverId', '');
                                                            }
                                                          }}
                                                          onInputChange={(event, newInputValue, reason) => {
                                                            if (reason === 'input' || reason === 'clear') {
                                                              setFieldValue('receiverName', newInputValue);
                                                            }
                                                          }}
                                                          onBlur={(event) => {
                                                            setFieldTouched('receiverName', true);
                                                            const inputValue = event.target.value;
                                                            if (inputValue && !values.receiverId) {
                                                              const matchedOption = receiverList.find(option =>
                                                                `${option.receiver_Name} - ${option.receiver_ContactNo}` === inputValue
                                                              );
                                                              if (matchedOption) {
                                                                setFieldValue('receiverName', matchedOption.receiver_Name);
                                                                setFieldValue('receiverId', matchedOption.receiver_Id);
                                                              }
                                                            }
                                                          }}
                                                          size="small"
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              label="Name"
                                                              inputRef={el => { fieldRefs.current.receiverName = el; }}
                                                              value={values.receiverName ? values.receiverName : ''}
                                                              error={touched.receiverName && Boolean(errors.receiverName)}
                                                              helperText={touched.receiverName && errors.receiverName}
                                                              FormHelperTextProps={{
                                                                style: { color: 'red' },
                                                              }}
                                                              required
                                                            />
                                                          )}
                                                          disabled={isDisabled}
                                                          noOptionsText="No Receiver available"
                                                          freeSolo
                                                        />
                                                      </FormControl>
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Contact No"
                                                        type="text"
                                                        name="receiverPhone"
                                                        inputRef={el => { fieldRefs.current.receiverPhone = el; }}
                                                        required
                                                        onBlur={handleBlur}
                                                        error={touched.receiverPhone && !!errors.receiverPhone}
                                                        helperText={touched.receiverPhone && errors.receiverPhone ? errors.receiverPhone : ''}
                                                        value={values.receiverPhone}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                          handleChange({ target: { name: 'receiverPhone', value: numericValue } });
                                                        }}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Alternative Contact No"
                                                        type="text"
                                                        name="receiverAlterPhone"
                                                        onBlur={handleBlur}
                                                        error={touched.receiverAlterPhone && !!errors.receiverAlterPhone}
                                                        helperText={touched.receiverAlterPhone && errors.receiverAlterPhone ? errors.receiverAlterPhone : ''}
                                                        value={values.receiverAlterPhone}
                                                        disabled={isDisabled}
                                                        onChange={(e) => {
                                                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                          handleChange({ target: { name: 'receiverAlterPhone', value: numericValue } });
                                                        }}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={12} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Email"
                                                        type="email"
                                                        name="receiverEmail"
                                                        onBlur={handleBlur}
                                                        error={touched.receiverEmail && !!errors.receiverEmail}
                                                        helperText={touched.receiverEmail && errors.receiverEmail ? errors.receiverEmail : ''}
                                                        value={values.receiverEmail}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 1"
                                                        name="receiverAddr1"
                                                        inputRef={el => { fieldRefs.current.receiverAddr1 = el; }}
                                                        required
                                                        onBlur={handleBlur}
                                                        error={touched.receiverAddr1 && !!errors.receiverAddr1}
                                                        helperText={touched.receiverAddr1 && errors.receiverAddr1 ? errors.receiverAddr1 : ''}
                                                        value={values.receiverAddr1}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 2"
                                                        name="receiverAddr2"
                                                        onBlur={handleBlur}
                                                        error={touched.receiverAddr2 && !!errors.receiverAddr2}
                                                        helperText={touched.receiverAddr2 && errors.receiverAddr2 ? errors.receiverAddr2 : ''}
                                                        value={values.receiverAddr2}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        label="Address 3"
                                                        name="receiverAddr3"
                                                        onBlur={handleBlur}
                                                        error={touched.receiverAddr3 && !!errors.receiverAddr3}
                                                        helperText={touched.receiverAddr3 && errors.receiverAddr3 ? errors.receiverAddr3 : ''}
                                                        value={values.receiverAddr3}
                                                        disabled={isDisabled}
                                                        onChange={handleChange}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <FormControl fullWidth size="small">
                                                        <Autocomplete
                                                          options={countryList || []}
                                                          getOptionLabel={(country) => country.CountryName || ''}
                                                          renderOption={(props, country) => (
                                                            <li {...props} key={country.CountryId}>
                                                              {country.CountryName}
                                                            </li>
                                                          )}
                                                          isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                                                          value={
                                                            countryList.find((country) => country.CountryId === values.receiverCountry) ||
                                                            null
                                                          }
                                                          name="receiverCountry"
                                                          onChange={(event, value) => {
                                                            if (value) {
                                                              setreceiverCountryErr(false);
                                                              setFieldValue('receiverCountry', value.CountryId);
                                                              setReceiverCountryId(value.CountryId);
                                                              handleCountryChangereceiver(value, handleChange);
                                                              GetShipperPrice(value.CountryId, boxDetails);
                                                            } else {
                                                              setFieldValue('receiverCountry', '');
                                                            }
                                                          }}
                                                          disabled
                                                          onBlur={() => setFieldTouched('receiverCountry', true)}
                                                          size="small"
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              label="Receiver Country"
                                                              value={values.receiverCountry ? values.receiverCountry : ''}
                                                              helperText={receiverCountryErr ? 'Receiver Country is required' : ''}
                                                              FormHelperTextProps={{
                                                                style: { color: 'red' },
                                                              }}
                                                              required
                                                            />
                                                          )}
                                                          noOptionsText="No country available"
                                                        />
                                                      </FormControl>
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <FormControl fullWidth size="small">
                                                        <Autocomplete
                                                          options={receiverStateList || []}
                                                          getOptionLabel={(state) => state.StateName || ''}
                                                          renderOption={(props, state) => (
                                                            <li {...props} key={state.StateId}>
                                                              {state.StateName}
                                                            </li>
                                                          )}
                                                          isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                                          value={
                                                            receiverStateList.find((state) => state.StateId === values.receiverState) || null
                                                          }
                                                          name="receiverState"
                                                          onChange={(event, value) => {
                                                            if (value) {
                                                              setFieldValue('receiverState', value.StateId);
                                                            } else {
                                                              setFieldValue('receiverState', '');
                                                            }
                                                          }}
                                                          disabled={isDisabled}
                                                          onBlur={() => setFieldTouched('receiverState', true)}
                                                          size="small"
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              label="Receiver Province/State"
                                                              value={values.receiverState ? values.receiverState : ''}
                                                              error={touched.receiverState && !!errors.receiverState}
                                                              helperText={touched.receiverState && errors.receiverState}
                                                            />
                                                          )}
                                                          noOptionsText="No Province/State available"
                                                        />
                                                      </FormControl>
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="City"
                                                        type="text"
                                                        required
                                                        name="receiverCity"
                                                        inputRef={el => { fieldRefs.current.receiverCity = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.receiverCity && !!errors.receiverCity}
                                                        helperText={touched.receiverCity && errors.receiverCity ? errors.receiverCity : ''}
                                                        value={values.receiverCity}
                                                        onChange={handleChange}
                                                        disabled={isDisabled}
                                                      />
                                                    </Grid>
                      
                                                    <Grid item md={6} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Postal Code"
                                                        type="text"
                                                        name="receiverPincode"
                                                        inputRef={el => { fieldRefs.current.receiverPincode = el; }}
                                                        onBlur={handleBlur}
                                                        error={touched.receiverPincode && !!errors.receiverPincode}
                                                        helperText={touched.receiverPincode && errors.receiverPincode ? errors.receiverPincode : ''}
                                                        required
                                                        value={values.receiverPincode}
                                                        onChange={handleChange}
                                                        disabled={isDisabled}
                                                      />
                                                    </Grid>
                                         
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                      
                                            {/* ID Card Details Section */}
                      <Grid item xs={12} m={0}>
                        <Grid
                          container
                          spacing={2}
                          rowSpacing={2}
                          columnSpacing={2}
                          component={Paper}
                          p={1}
                          m={0}
                          elevation={3}
                          sx={{
                            width: '100%',
                            bgcolor: 'inherit',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                          }}
                        >
                          {/* Main container for all three sections in one row */}
                          <Grid container spacing={2} sx={{ mt: 0, p: 0, width: '100%' }}>
                            {/* Sender Section - Left Column */}
                            <Grid item md={4} xs={12}>
                              <Stack direction="column"  sx={{ height: '100%' }}>
                                {/* Sender Image */}
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  border={1}
                                  borderRadius={1}
                                  borderColor="#e0e0e0"
                                  p={1}
                                  justifyContent="center"
                                  sx={{
                                    height: '100%',
                                    bgcolor: 'background.paper',
                                    minHeight: { xs: 'auto', md: '180px' }
                                  }}
                                >
                                  <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                    <Box sx={{ textAlign: 'center', width: '100%' }}>
                                      <label htmlFor="fileInputSender">
                                        <img
                                          src={
                                            senderImagePreview || imagepreview
                                            // (senderImageFile === null ||
                                            //   senderImageFile === '' ||
                                            //   !senderImageFile
                                            //   ? imagepreview
                                            //   : NoimageFound)
                                          }
                                          alt="No Img"
                                          className={classes.chooseFileButton}
                                          style={{
                                            width: '100%',
                                            maxWidth: '250px',
                                            height: '150px',
                                            objectFit: 'contain',
                                          }}
                                           onError={(e) => {
                                          e.target.onerror = null; // Prevent infinite loop
                                          e.target.src = imagepreview;
                                          setSendPreviewBtn(false)
                                        }}
                                        />
                                        <input
                                          className={classes.fileInput}
                                          id="fileInputSender"
                                          type="file"
                                          accept="image/jpeg"
                                          name="IDcardFile"
                                          onClick={(event)=>{
                                            if ((!values.IdCardNo || values.IdCardNo.trim() === '') || values.IdCardNo.trim() === '0') {
                                            openSnackBar('Please enter ID Card No before uploading image', 'error');
                                            event.preventDefault()
                                            event.stopPropagation()
                                            return;
                                          }
                                          }}
                                          onChange={(event) => {
                                            handleIdFileChange(event, 'sender', values);
                                            handleChange(event);
                                          }}
                                          
                                          style={{ display: 'none' }}
                                          disabled={isDisabled}
                                        />
                                      </label>
                                      {((senderImagePreview || senderImageFile ) && (sendPreviewBtn)) && (
                                        <Button
                                          onClick={() => handleOpenDialogPreview('sender')}
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          sx={{
                                            boxShadow: 1,
                                            mt: 1,
                                            width: '100%',
                                            maxWidth: '250px',
                                            mx: 'auto'
                                          }}
                                        >
                                          Preview
                                        </Button>
                                      )}
                                    </Box>
                                  </Stack>
                                </Stack>
                      
                                {/* Sender ID Card Type and Number */}
                                <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                                  <Grid item xs={12} md={12}>
                                    <FormControl fullWidth size="small">
                                      <InputLabel>ID Card Type</InputLabel>
                                      <Select
                                        value={values.idCardType || ''}
                                        name="idCardType"
                                        size="small"
                                        label="ID Card Type"
                                       onChange={(e) => { 
                          const newValue = e.target.value;
                          
                          // Check if in edit mode and value has changed from initial
                          if (Type === 'Edit' && initialValue.idCardType && newValue !== initialValue.idCardType) {
                            // If there's an existing image, show confirmation dialog
                            if (senderImageFile || senderImagePreview) {
                              setPendingIdCardChanges(prev => ({ 
                                ...prev, 
                                sender: { newValue, field: 'idCardType', isTypeChange: true } 
                              }));
                              setShowIdCardChangeDialog(prev => ({ ...prev, sender: true }));
                              return; // Don't update the field yet
                            }
                          }
                          
                          // Update the field immediately if no image or not in edit mode
                          setFieldValue('IdCardNo', '');
                          setSenderImageFile(null);
                          setSenderImagePreview('');
                          setFieldValue('idCardType', newValue || '');
                          const senderInput = document.getElementById('fileInputSender');
                          if (senderInput) {
                            senderInput.value = '';
                          }
                        }}
                                        onBlur={handleBlur}
                                        error={touched.idCardType && !!errors.idCardType}
                                        disabled={isDisabled}
                                      >
                                        {idCardTypes.map((idCard) => (
                                          <MenuItem key={idCard.id} value={idCard.id}>
                                            {idCard.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                      
                                  <Grid item xs={12} md={12}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label={
                                        <span>
                                          ID Card No
                                          {values.idCardType && values.idCardType !== '' && values.idCardType !== '0' ?
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span> : null
                                          }
                                        </span>
                                      }
                                      type="text"
                                      name="IdCardNo"
                                      inputRef={el => { fieldRefs.current.IdCardNo = el; }}
                                      onBlur={handleBlur}
                                      error={touched.IdCardNo && !!errors.IdCardNo}
                                      helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                                      value={values.IdCardNo || ''}
                           onChange={(e) => {
                        const newValue = e.target.value;
                        
                        // Check if in edit mode and value has changed from initial
                        if (Type === 'Edit' && initialValue.IdCardNo && newValue !== initialValue.IdCardNo) {
                          // If there's an existing image, show confirmation dialog
                          if (senderImageFile || senderImagePreview) {
                            setPendingIdCardChanges(prev => ({ 
                              ...prev, 
                              sender: { newValue, field: 'IdCardNo' } 
                            }));
                            setShowIdCardChangeDialog(prev => ({ ...prev, sender: true }));
                            return; // Don't update the field yet
                          }
                        }
                        
                        // Update the field immediately if no image or not in edit mode
                        handleChange(e);
                        
                        // Clear the image and file input
                        setSenderImageFile(null);
                        setSenderImagePreview('');
                        const senderInput = document.getElementById('fileInputSender');
                        if (senderInput) {
                          senderInput.value = '';
                        }
                      }}
                                      disabled={!(values.idCardType && values.idCardType !== '' && values.idCardType !== '0')}
                                      inputProps={{ maxLength: 30 }}
                                    />
                                  </Grid>
                                </Grid>
                              </Stack>
                            </Grid>
                      
                            {/* Remarks Section - Middle Column */}
                            <Grid item md={4} xs={12}>
                              <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  height: '100%',
                                  minHeight: { xs: 'auto', md: '250px' },
                                  p: 2,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    color: 'text.secondary',
                                    lineHeight: 1.4
                                  }}
                                >
                                 {sessionStorage.getItem('Origin') === 'SL' ? '' : <span style={{ color: 'red', display: 'block', marginBottom: 1 }}>Remarks</span>}
                                  {sessionStorage.getItem('Origin') === 'UK' 
                                    ? '“Dear Customer kindly upload the receiver document accordingly in the respective image upload option”'
                                    : sessionStorage.getItem('Origin') === 'IN' ? '“Dear Customer kindly upload the Sender document accordingly in the respective image upload option”'
                                    : ''}
                                </Typography>
                              </Stack>
                            </Grid>
                      
                            {/* Receiver Section - Right Column */}
                            <Grid item md={4} xs={12}>
                              <Stack direction="column"  sx={{ height: '100%' }}>
                                {/* Receiver Image */}
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  border={1}
                                  borderRadius={1}
                                  borderColor="#e0e0e0"
                                  p={1}
                                  justifyContent="center"
                                  sx={{
                                    height: '100%',
                                    bgcolor: 'background.paper',
                                    minHeight: { xs: 'auto', md: '180px' }
                                  }}
                                >
                                  <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                    <Box sx={{ textAlign: 'center', width: '100%' }}>
                                      <label htmlFor="fileInputReceiver">
                                        <img
                                          src={
                                            receiverImagePreview || imagepreview
                                            // (receiverImageFile === null ||
                                            //   receiverImageFile === '' ||
                                            //   !receiverImageFile
                                            //   ? imagepreview
                                            //   : NoimageFound)
                                          }
                                          alt="No Img"
                                          className={classes.chooseFileButton}
                                          style={{
                                            width: '100%',
                                            maxWidth: '250px',
                                            height: '150px',
                                            objectFit: 'contain',
                                          }}
                                           onError={(e) => {
                                            e.target.onerror = null; // Prevent infinite loop
                                            e.target.src = imagepreview;
                                            setReceivPreviewBtn(false)
                                          }}
                                        />
                                        <input
                                          className={classes.fileInput}
                                          id="fileInputReceiver"
                                          type="file"
                                          accept="image/jpeg"
                                          name="RecIDcardFile"
                                          onClick={(event)=>{
                                            if ((!values.RecIdCardNo || values.RecIdCardNo.trim() === '') ||  values.RecIdCardNo.trim() === '0') {
                                              openSnackBar('Please enter ID Card No before uploading image', 'error');
                                              event.preventDefault()
                                              event.stopPropagation();
                                              return;
                                            }
                                          }}
                                          onChange={(event) => {
                                            handleIdFileChange(event, 'receiver', values);
                                            handleChange(event);
                                          }}
                                          style={{ display: 'none' }}
                                          disabled={isDisabled}
                                        />
                                      </label>
                                      {((receiverImagePreview || receiverImageFile ) && (receivPreviewBtn)) && (
                                        <Button
                                          onClick={() => handleOpenDialogPreview('receiver')}
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          sx={{
                                            boxShadow: 1,
                                            mt: 1,
                                            width: '100%',
                                            maxWidth: '250px',
                                            mx: 'auto'
                                          }}
                                        >
                                          Preview
                                        </Button>
                                      )}
                                    </Box>
                                  </Stack>
                                </Stack>
                      
                                {/* Receiver ID Card Type and Number */}
                                <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                                  <Grid item xs={12} md={12}>
                                    <FormControl fullWidth size="small">
                                      <InputLabel>ID Card Type</InputLabel>
                                      <Select
                                        value={values.RecidCardType || ''}
                                        name="RecidCardType"
                                        size="small"
                                        label="ID Card Type"
                                        onChange={(e) => {
                          const newValue = e.target.value;
                          
                          // Check if in edit mode and value has changed from initial
                          if (Type === 'Edit' && initialValue.RecidCardType && newValue !== initialValue.RecidCardType) {
                            // If there's an existing image, show confirmation dialog
                            if (receiverImageFile || receiverImagePreview) {
                              setPendingIdCardChanges(prev => ({ 
                                ...prev, 
                                receiver: { newValue, field: 'RecidCardType', isTypeChange: true } 
                              }));
                              setShowIdCardChangeDialog(prev => ({ ...prev, receiver: true }));
                              return; // Don't update the field yet
                            }
                          }
                          
                          // Update the field immediately if no image or not in edit mode
                          setFieldValue('RecIdCardNo', '');
                          setReceiverImageFile(null);
                          setReceiverImagePreview('');
                          setFieldValue('RecidCardType', newValue || '');
                          const receiverInput = document.getElementById('fileInputReceiver');
                          if (receiverInput) {
                            receiverInput.value = '';
                          }
                        }}
                                        onBlur={handleBlur}
                                        error={touched.RecidCardType && !!errors.RecidCardType}
                                        disabled={isDisabled}
                                      >
                                        {idCardTypes.map((idCard) => (
                                          <MenuItem key={idCard.id} value={idCard.id}>
                                            {idCard.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                      
                                  <Grid item xs={12} md={12}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label={
                                        <span>
                                          ID Card No
                                          {values.RecidCardType && values.RecidCardType !== '' && values.RecidCardType !== '0' ?
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span> : null
                                          }
                                        </span>
                                      }
                                      type="text"
                                      name="RecIdCardNo"
                                      inputRef={el => { fieldRefs.current.RecIdCardNo = el; }}
                                      onBlur={handleBlur}
                                      error={touched.RecIdCardNo && !!errors.RecIdCardNo}
                                      helperText={touched.RecIdCardNo && errors.RecIdCardNo ? errors.RecIdCardNo : ''}
                                      value={values.RecIdCardNo || ''}
                           onChange={(e) => {
                        const newValue = e.target.value;
                        
                        // Check if in edit mode and value has changed from initial
                        if (Type === 'Edit' && initialValue.RecIdCardNo && newValue !== initialValue.RecIdCardNo) {
                          // If there's an existing image, show confirmation dialog
                          if (receiverImageFile || receiverImagePreview) {
                            setPendingIdCardChanges(prev => ({ 
                              ...prev, 
                              receiver: { newValue, field: 'RecIdCardNo' } 
                            }));
                            setShowIdCardChangeDialog(prev => ({ ...prev, receiver: true }));
                            return; // Don't update the field yet
                          }
                        }
                        
                        // Update the field immediately if no image or not in edit mode
                        handleChange(e);
                        
                        // Clear the image and file input
                        setReceiverImageFile(null);
                        setReceiverImagePreview('');
                        const receiverInput = document.getElementById('fileInputReceiver');
                        if (receiverInput) {
                          receiverInput.value = '';
                        }
                      }}
                                      disabled={!(values.RecidCardType && values.RecidCardType !== '' && values.RecidCardType !== '0')}
                                      inputProps={{ maxLength: 30 }}
                                    />
                                  </Grid>
                          
                                </Grid>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* ID Card Change Confirmation Dialog for Sender */}
                      <Dialog
                        open={showIdCardChangeDialog.sender}
                        onClose={() => setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }))}
                      >
                        <DialogTitle>
                          {pendingIdCardChanges.sender?.isTypeChange 
                            ? 'Confirm ID Card Type Change' 
                            : 'Confirm ID Card Number Change'}
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            {pendingIdCardChanges.sender?.isTypeChange 
                              ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                              : 'If you change the ID card number, the existing ID card image will be removed.'}
                            <br /><br />
                            Do you want to proceed? You will need to upload a new ID card image
                             {pendingIdCardChanges.sender?.isTypeChange ?' and ID card number.' : '.'}
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button 
                            onClick={() => {
                              // User clicked Cancel - revert to original value
                              if (pendingIdCardChanges.sender?.field === 'idCardType') {
                                setFieldValue('idCardType', initialValue.idCardType || '');
                              } else {
                                setFieldValue('IdCardNo', initialValue.IdCardNo || '');
                              }
                              setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }));
                              setPendingIdCardChanges(prev => ({ ...prev, sender: null }));
                            }}
                            color="primary"
                          >
                            Cancel
                          </Button>
                          <Button 
                            onClick={() => {
                              // User clicked Confirm - proceed with change
                              if (pendingIdCardChanges.sender?.field === 'idCardType') {
                                setFieldValue('idCardType', pendingIdCardChanges.sender.newValue);
                                // Also clear ID card number when type changes
                                setFieldValue('IdCardNo', '');
                              } else {
                                setFieldValue('IdCardNo', pendingIdCardChanges.sender.newValue);
                              }
                              
                              // Clear the image and file input
                              setSenderImageFile(null);
                              setSenderImagePreview('');
                              const senderInput = document.getElementById('fileInputSender');
                              if (senderInput) {
                                senderInput.value = '';
                              }
                              
                              setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }));
                              setPendingIdCardChanges(prev => ({ ...prev, sender: null }));
                            }}
                            color="error"
                            variant="contained"
                          >
                            Confirm & Remove Image
                          </Button>
                        </DialogActions>
                      </Dialog>
                      
                      {/* ID Card Change Confirmation Dialog for Receiver */}
                      <Dialog
                        open={showIdCardChangeDialog.receiver}
                        onClose={() => setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }))}
                      >
                        <DialogTitle>
                          {pendingIdCardChanges.receiver?.isTypeChange 
                            ? 'Confirm ID Card Type Change' 
                            : 'Confirm ID Card Number Change'}
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            {pendingIdCardChanges.receiver?.isTypeChange 
                              ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                              : 'If you change the ID card number, the existing ID card image will be removed.'}
                            <br /><br />
                            Do you want to proceed? You will need to upload a new ID card image  
                            {pendingIdCardChanges.receiver?.isTypeChange ?' and ID card number.' : '.'}
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button 
                            onClick={() => {
                              // User clicked Cancel - revert to original value
                              if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                                setFieldValue('RecidCardType', initialValue.RecidCardType || '');
                              } else {
                                setFieldValue('RecIdCardNo', initialValue.RecIdCardNo || '');
                              }
                              setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }));
                              setPendingIdCardChanges(prev => ({ ...prev, receiver: null }));
                            }}
                            color="primary"
                          >
                            Cancel 
                          </Button>
                          <Button 
                            onClick={() => {
                              // User clicked Confirm - proceed with change
                              if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                                setFieldValue('RecidCardType', pendingIdCardChanges.receiver.newValue);
                                // Also clear ID card number when type changes
                                setFieldValue('RecIdCardNo', '');
                              } else {
                                setFieldValue('RecIdCardNo', pendingIdCardChanges.receiver.newValue);
                              }
                              
                              // Clear the image and file input
                              setReceiverImageFile(null);
                              setReceiverImagePreview('');
                              const receiverInput = document.getElementById('fileInputReceiver');
                              if (receiverInput) {
                                receiverInput.value = '';
                              }
                              
                              setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }));
                              setPendingIdCardChanges(prev => ({ ...prev, receiver: null }));
                            }}
                            color="error"
                            variant="contained"
                          >
                            Confirm & Remove Image
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Grid item md={12} xs={12}>
                        <Divider sx={{ my: 2 }} variant="middle">
                          {/* <Chip label="Collection/Drop Details" size="small" color="success" variant="outlined" /> */}
                          <Chip label="Branch Details" size="small" color="success" variant="outlined" />
                        </Divider>
                      </Grid>
                      {/* <Grid item xs={6}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel>Collection/Drop</InputLabel>
                          <Select
                            value={values.pickUpType || ''}
                            name="pickUpType"
                            size="small"
                            label="Collection/Drop"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisabled}
                            error={touched.pickUpType && !!errors.pickUpType}
                            required
                          >
                            {pickupTypes.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.pickUpType && errors.pickUpType && (
                            <Typography
                              variant="caption"
                              color="error"
                              className="shake-helper-text"
                              margin="4px 0 0 14px"
                            >
                              {errors.pickUpType}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid> */}
                      <Grid item md={12} xs={12}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel>Branch</InputLabel>
                          <Select
                            value={values.branch || ''}
                            name="branch"
                            inputRef={el => { fieldRefs.current.branch = el; }}
                            size="small"
                            label="Branch"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.branch && !!errors.branch}
                            disabled={isDisabled}
                            required
                          >
                            {branchList.length > 0 ? (
                              branchList.map((branch) => (
                                <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                  {branch.BranchName}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No branches available</MenuItem>
                            )}
                          </Select>
                          {touched.branch && errors.branch && (
                            <Typography
                              variant="caption"
                              color="error"
                              className="shake-helper-text"
                              margin="4px 0 0 14px"
                            >
                              {errors.branch}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid> </> )}

                   {bookingStarted && ( 
                    <>   <Grid item md={12} xs={12}>
                        <Divider sx={{ my: 2 }} variant="middle">
                          {/* <Chip label="Collection/Drop Details" size="small" color="success" variant="outlined" /> */}
                          <Chip label="Box Details" size="small" color="info" variant="outlined" />
                        </Divider>
                      </Grid>       

                 
                    
                      {boxDetails.length > 0 &&
                        boxDetails.map((box, index) => (
                          <Grid item md={12} xs={12} key={index}>
                             <Paper
                    elevation={2}
                    sx={{
                      p: 2,
                      mb: 1,
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      backgroundColor: 'background.paper',
                      '&:hover': {
                        boxShadow: 3,
                      },
                      transition: 'all 0.3s ease',
                    }}
                  >
                              <Typography variant="h6" align="left" color="#295F98"
                                      sx={{pb:1}}>
                                        Box {box.boxNo} - Details & Descriptions
                                      </Typography>
                            <Accordion
                              expanded={expanded[index] || false}
                              // onClick={() => {
                              //   toggleAccordion(index)
                              // }}
                              py={2}
                              sx={{
                                backgroundColor: 'inherit',
                                border: 0,
                                borderColor: '#80808038',
                                borderRadius: 2,
                                boxShadow: 1,
                                p: 0, // Reduce padding from p: 1 to p: 0
                                mt: 0.5, // Reduce margin top from mt: 2
                                mb: 1, 
                                cursor: 'pointer',
                              }}
                              elevation={7}
                            >
                      
                              <AccordionSummary
                                aria-controls={`panel${index}bh-content`}
                                id={`panel${index}bh-header`}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  toggleAccordion(index)
                                }}
                                sx={{
                                  '&.Mui-expanded': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:focus-within': {
                                    backgroundColor: 'transparent',
                                  },
                                  pb: 1,
                                }}
                              >
                              
                                <Grid container spacing={2} alignItems="center">
                                   <Grid item md={2} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="No of Items"
                                          type="number"
                                          value={box.noOfItems}
                                          // disabled={isDisabled}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newNoOfItems = parseFloat(e.target.value) || '';
                                            if (newNoOfItems > 0 || newNoOfItems === '') {
                                              updatedBoxes[index].noOfItems = newNoOfItems;
                                              setBoxDetails(updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].noOfItems`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].noOfItems`] &&
                                            touched[`boxDetails[${index}].noOfItems`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].noOfItems`] &&
                                            errors[`boxDetails[${index}].noOfItems`]
                                          }
                                          // disabled={isDisabled || box.goods.length > 0}
                                          // disabled={!isloadvisible}
                                          disabled={!boxLoadEnabled[index]} 
                                          required
                                           onClick={(e) => {
                                          e.stopPropagation(); // This prevents the click from bubbling up to the accordion
                                        }}
                                        // Also add this to prevent focus from triggering accordion
                                        onFocus={(e) => {
                                          e.stopPropagation();
                                        }}
                                        />
                                      </Grid>
                                       {/* {!box.goods.length > 0 && ( */}
                                       {/* {isloadvisible && (
                                    <Grid item md={1} xs={12}>
                                      {/* <Button
                                        onClick={() => {
                                          showLoading();
                                          const updatedBoxes = [...boxDetails];
                                          updatedBoxes[index].goods = Array.from(
                                            { length: updatedBoxes[index].noOfItems },
                                            () => ({
                                              goodsName: '',
                                              uom: '',
                                              quantity: 0,
                                              rate: 0,
                                              value: 0,
                                              newGoods: 'N',
                                              image: null,
                                            })
                                          );
                                          setBoxDetails(updatedBoxes);
                                          hideLoading();
                                          toggleAccordionTrue(index);
                                        }}
                                        variant="contained"
                                        color="warning"
                                        size="medium"
                                        fullWidth
                                      >
                                        Load
                                      </Button> */}
                                      {/* comment by yuki */}
                                      {/* <Button
                                        onClick={async () => {
                                          showLoading();
                                          // if (!validateBoxDetails(boxDetails[index], index)) {
                                          //   hideLoading();
                                          //   return; // Stop further processing if validation fails
                                          // }
                                          const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0
                                          // If validation passes, proceed with updating the box details
                                          const updatedBoxes = [...boxDetails];
                                          updatedBoxes[index].goods = Array.from(
                                            { length: updatedBoxes[index].noOfItems },
                                            () => ({
                                              goodsName: '',
                                              uom: '',
                                              UOM_Id: uom.UOM_Id,
                                              UOM_Description: uom.UOM_Description,
                                              quantity: '',
                                              rate: '',
                                              value: '',
                                              newGoods: 'N',
                                              image: null,
                                            })
                                          );

                                          setBoxDetails(updatedBoxes);
                                          hideLoading();
                                          toggleAccordion(index);

                                          const load = !isloadvisible
                                          setIsLoadVisible(load)
                                        }}
                                        variant="contained"
                                        color="warning"
                                        size="medium"
                                        fullWidth
                                      >
                                        Load
                                      </Button>
                                    </Grid>
                                  )}  */}
                                  {boxLoadEnabled[index] && (
  <Grid item md={1} xs={12}>
    <Button
      onClick={async () => {
        showLoading();
        const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0;
        const updatedBoxes = [...boxDetails];
        updatedBoxes[index].goods = Array.from(
          { length: updatedBoxes[index].noOfItems },
          () => ({
            goodsName: '',
            uom: '',
            UOM_Id: uom.UOM_Id,
            UOM_Description: uom.UOM_Description,
            quantity: '',
            rate: '',
            value: '',
            newGoods: 'N',
            image: null,
          })
        );

        setBoxDetails(updatedBoxes);
        
        // Disable load for this box after loading goods
        setBoxLoadEnabled(prev => ({
          ...prev,
          [index]: false
        }));
        
        hideLoading();
        toggleAccordion(index);
      }}
      variant="contained"
      color="warning"
      size="medium"
      fullWidth
    >
      Load
    </Button>
  </Grid>
)}
                                    {/* Spacer to push right side content to the end */}
                                  <Grid item md={box.goods.length > 0 ? 8 : 7} xs={12}>
                                   <Stack 
                                        direction="row" 
                                        spacing={1} 
                                        alignItems="center"
                                        justifyContent="flex-end">
                                        {/* Delete Icon Button */}
                                        {boxDetails.length > 1 && (
                                          <IconButton
                                            aria-label="delete"
                                            color="error"
                                            onClick={() => {
                                              handleOpenConfirmDialog(index);
                                            }}
                                            disabled={isDisabled}
                                          >
                                            <DeleteOutlineIcon />
                                          </IconButton>
                                        )}

                                        {/* Vertical Divider */}
                                        <Divider orientation="vertical" flexItem />

                                        {/* New: View Goods Button */}
                                        <Button
                                          variant="text"
                                          color="secondary"
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            toggleAccordion(index)
                                          }}
                                          sx={{
                                            textTransform: 'none',
                                            minWidth: 'fit-content',
                                            px: 0.5,
                                            fontSize: '0.85rem',
                                            whiteSpace: 'nowrap', // Prevents text wrapping
                                            overflow: 'hidden', // Hides overflow if needed
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {expanded[index] ? 'Hide Goods' : 'View Goods'}
                                        </Button>

                                        {/* Existing Expand Icon (modified) */}
                                        <IconButton
                                          aria-label="expand"
                                          color="secondary"
                                          size="small"
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            toggleAccordion(index)
                                          }}
                                          sx={{
                                            // Optional: highlight when expanded
                                            backgroundColor: expanded[index] ? 'action.hover' : 'transparent',
                                            borderRadius: '50%',
                                          }}
                                        >
                                          <ExpandMoreIcon
                                            sx={{
                                              transform: expanded[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                                              transition: 'transform 0.3s ease',
                                            }}
                                          />
                                        </IconButton>
                                      </Stack>
                                      </Grid>
                                 
                                 
                                </Grid>
                              </AccordionSummary>
                              <AccordionDetails>
                                {box.goods.length > 0 && (
                                  <>
                                    <Divider>
                                      <Chip label="Goods Description" size="small" color="primary" variant="outlined" />
                                    </Divider>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" my={1}>
                                      <Typography sx={{ fontSize: 13 }}>
                                        <span style={{ color: '#05f725', fontWeight: 'bold' }}>*</span>Note: To add any goods which are not in the list,
                                        Click 'Create Your Product'.
                                      </Typography>
                                      <Button
                                        onClick={() => handleAddGoods(index, 'Y')}
                                        variant="outlined"
                                        color="success"
                                        size="small"
                                        disabled={isDisabled}
                                      >
                                        Create Your Product
                                      </Button>
                                    </Stack>
                                    <Grid container spacing={2} my={1}>
                                      {box.goods.map((goods, goodsIndex) => {
                                        const filteredGoodsList = goodsList.filter(
                                          (item) =>
                                            !box.goods.some(
                                              (otherGoods, otherIndex) =>
                                                otherIndex !== goodsIndex &&
                                                Number(otherGoods.GoodsId) === Number(item.GoodsId)
                                            )
                                        );
                                        return (
                                          <Grid item md={12} xs={12} key={`${index}-${goodsIndex}`}>
                                            <Paper
                                              elevation={2}
                                              sx={{
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 2,
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                backgroundColor: 'background.paper',
                                                '&:hover': {
                                                  boxShadow: 3,
                                                },
                                                transition: 'all 0.3s ease',
                                              }}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid item md={9} xs={12}>
                                                  <Stack
                                                    direction="row"
                                                    spacing={2}
                                                    sx={{
                                                      justifyContent: 'space-evenly',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <Typography
                                                      variant="subtitle2"
                                                      align="center"
                                                      sx={{
                                                        bgcolor: goods.newGoods === 'Y' ? 'orange' : '#55679C',
                                                        borderRadius: '100%',
                                                        color: 'white',
                                                        width: '30px', // Set equal width
                                                        height: '30px', // Set equal height
                                                        display: 'flex', // Ensure proper alignment
                                                        alignItems: 'center', // Center content vertically
                                                        justifyContent: 'center', // Center content horizontally
                                                      }}
                                                    >
                                                      {goodsIndex + 1}
                                                    </Typography>

                                                    {goods.newGoods === 'Y' && goods.GoodsId === '0' ? (
                                                      <Tooltip
                                                        title={goods.goodsName || ''}
                                                        placement="top"
                                                        arrow
                                                        disableHoverListener={!goods.goodsName} // Only show if there's a value
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          size="small"
                                                          label={
                                                            goods.APPROVAL === 'R' ? (
                                                              <span>
                                                                Goods{' '}
                                                                <span style={{ color: 'red' }}>
                                                                  ( Rejected in Approval)
                                                                </span>
                                                              </span>
                                                            ) : goods.APPROVAL === 'Y' ? (
                                                              <span>
                                                                Goods{' '}
                                                                <span style={{ color: 'green' }}>
                                                                  ( Approved)
                                                                </span>
                                                              </span>
                                                            ) : (
                                                              'Goods'
                                                            )
                                                          }

                                                          // label={
                                                          //   goods.APPROVAL === 'R' ? (
                                                          //     <span style={{ color: 'red' }}>
                                                          //       Goods Rejected in Approval
                                                          //     </span>
                                                          //   ) : (
                                                          //     'Goods'
                                                          //   )
                                                          // }
                                                          value={goods.goodsName}
                                                          disabled={isDisabled || goods.APPROVAL === 'R'}
                                                          onChange={(e) =>
                                                            handleGoodsChangeY(
                                                              index,
                                                              goodsIndex,
                                                              'goodsName',
                                                              e.target.value
                                                            )
                                                          }
                                                          name={`boxDetails[${index}].goods[${goodsIndex}].goodsName`}
                                                          error={Boolean(
                                                            errors[`boxDetails[${index}].goods[${goodsIndex}].goodsName`] &&
                                                            touched[`boxDetails[${index}].goods[${goodsIndex}].goodsName`]
                                                          )}
                                                          helperText={
                                                            touched[
                                                            `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                            ] &&
                                                            errors[`boxDetails[${index}].goods[${goodsIndex}].goodsName`]
                                                          }
                                                          onBlur={handleBlur}
                                                          required
                                                        />
                                                      </Tooltip>
                                                    ) : (
                                                      <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        options={filteredGoodsList} // Array of goods options
                                                        filterOptions={startsWithFilter} // Custom filter
                                                        getOptionLabel={(option) => option.GoodsName || ''} // Customize display value
                                                        renderOption={(props, option) => (
                                                          <li {...props} key={option.GoodsId}>
                                                            {option.GoodsName}
                                                          </li>
                                                        )}
                                                        value={
                                                          goodsList.find(
                                                            (item) => Number(item.GoodsId) === Number(goods.GoodsId)
                                                          ) || null
                                                        }
                                                        disabled={isDisabled || goods.APPROVAL === 'R'}
                                                        onChange={(event, value) => {
                                                          if (value?.NotApplicable === 'Y') {
                                                            alert('This item is not applicable and cannot be selected.');
                                                            return;
                                                          }
                                                          // handleGoodsChange(index, goodsIndex, 'goodsName', value ? value.GoodsName : ''); // Update value
                                                          handleGoodsChange(index, goodsIndex, 'goods', value || {});
                                                        }}
                                                        isOptionEqualToValue={(option, value) =>
                                                          option.GoodsId === value?.GoodsId
                                                        }
                                                        required
                                                        renderInput={(params) => (
                                                          <Tooltip
                                                            title={params.inputProps.value || ''}
                                                            placement="top"
                                                            arrow
                                                            disableHoverListener={!params.inputProps.value} // Only show if there's a value
                                                          >
                                                            <TextField
                                                              {...params}
                                                              required
                                                              label={
                                                                goods.APPROVAL === 'R' ? (
                                                                  <span>
                                                                    Goods{' '}
                                                                    <span style={{ color: 'red' }}>
                                                                      ( Rejected in Approval)
                                                                    </span>
                                                                  </span>
                                                                ) : goods.APPROVAL === 'Y' ? (
                                                                  <span>
                                                                    Goods{' '}
                                                                    <span style={{ color: 'green' }}>
                                                                      ( Approved)
                                                                    </span>
                                                                  </span>
                                                                ) : (
                                                                  'Goods'
                                                                )
                                                              }

                                                              // label={
                                                              //   goods.APPROVAL === 'R' ? (
                                                              //     <span>
                                                              //       Goods{' '}
                                                              //       <span style={{ color: 'red' }}>
                                                              //         ( Rejected in Approval)
                                                              //       </span>
                                                              //     </span>
                                                              //   ) : (
                                                              //     'Goods'
                                                              //   )
                                                              // }
                                                              name={`boxDetails[${index}].goods[${goodsIndex}].goodsName`}
                                                              error={Boolean(
                                                                errors[
                                                                `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ] &&
                                                                touched[
                                                                `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ]
                                                              )}
                                                              helperText={
                                                                touched[
                                                                `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ] &&
                                                                errors[
                                                                `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ]
                                                              }
                                                              onBlur={handleBlur}
                                                            />
                                                          </Tooltip>
                                                        )}
                                                      />
                                                    )}
                                                  </Stack>
                                                </Grid>
                                              {hideUom &&  <Grid item md={3} xs={12}>
                                                  <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    options={uomList} // Array of goods options
                                                    getOptionLabel={(option) => option.UOM_Description || ''} // Customize display value
                                                    renderOption={(props, option) => (
                                                      <li {...props} key={option.UOM_Id}>
                                                        {option.UOM_Description}
                                                      </li>
                                                    )}
                                                    value={uomList.find((item) => item.UOM_Id === goods.UOM_Id) || null}
                                                    onChange={(event, value) => {
                                                      handleGoodsChange(index, goodsIndex, 'uom', value || {}); // Update value
                                                    }}
                                                    isOptionEqualToValue={(option, value) =>
                                                      option.UOM_Id === value?.UOM_Id
                                                    }
                                                    disabled={isDisabled || goods.APPROVAL === 'R'}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        label="UOM"
                                                        name={`boxDetails[${index}].goods[${goodsIndex}].uom`}
                                                        error={Boolean(
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].uom`] &&
                                                          touched[`boxDetails[${index}].goods[${goodsIndex}].uom`]
                                                        )}
                                                        helperText={
                                                          touched[`boxDetails[${index}].goods[${goodsIndex}].uom`] &&
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].uom`]
                                                        }
                                                        onBlur={handleBlur}
                                                      />
                                                    )}
                                                  />
                                                </Grid> }
                                                <Grid item md={4} xs={12}>
                                                  <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Quantity"
                                                    type="number"
                                                    value={goods.quantity}
                                                    disabled={isDisabled || goods.APPROVAL === 'R'}
                                                    onChange={(e) => {
                                                      const newQty = parseFloat(e.target.value) || '';
                                                      if (newQty > 0 || newQty === '') {
                                                        handleGoodsChange(index, goodsIndex, 'quantity', newQty);
                                                      }
                                                    }}
                                                    name={`boxDetails[${index}].goods[${goodsIndex}].quantity`}
                                                    onBlur={handleBlur}
                                                    error={Boolean(
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].quantity`] &&
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].quantity`]
                                                    )}
                                                    helperText={
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].quantity`] &&
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].quantity`]
                                                    }
                                                    required
                                                  />
                                                </Grid>
                                                <Grid item md={4} xs={12}>
                                                  <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Rate"
                                                    type="number"
                                                    value={goods.rate}
                                                    disabled={isDisabled || goods.APPROVAL === 'R'}
                                                    onChange={(e) => {
                                                      const newRate = parseFloat(e.target.value) || '';
                                                      if (newRate > 0 || newRate === '') {
                                                        handleGoodsChange(index, goodsIndex, 'rate', newRate);
                                                      }
                                                    }}
                                                    onBlur={handleBlur}
                                                    name={`boxDetails[${index}].goods[${goodsIndex}].rate`}
                                                    error={Boolean(
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                    )}
                                                    helperText={
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                    }
                                                  />
                                                </Grid>
                                                <Grid item md={4} xs={12}>
                                                  <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    sx={{
                                                      justifyContent: 'space-evenly',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      size="small"
                                                      label="Value"
                                                      type="number"
                                                      value={goods.value}
                                                      // disabled={isDisabled}
                                                      name={`boxDetails[${index}].goods[${goodsIndex}].value`}
                                                      onBlur={handleBlur}
                                                      error={Boolean(
                                                        errors[`boxDetails[${index}].goods[${goodsIndex}].value`] &&
                                                        touched[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                      )}
                                                      helperText={
                                                        touched[`boxDetails[${index}].goods[${goodsIndex}].value`] &&
                                                        errors[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                      }
                                                      disabled
                                                    />
                                                    {goods.newGoods === 'Y' && (
                                                      <Stack direction={'column'} spacing={2}>
                                                        <Stack
                                                          direction="row"
                                                          alignItems="center"
                                                          spacing={1}
                                                          border={1}
                                                          borderRadius={1}
                                                          borderColor="#e0e0e0"
                                                          p={1}
                                                          justifyContent="center"
                                                        >
                                                          <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent={'center'}
                                                            spacing={1}
                                                          >
                                                            <Box title="click to add image">
                                                              <label htmlFor={`fileInput-${index}-${goodsIndex}`}>
                                                                <img
                                                                  src={
                                                                    /\.(jpg|jpeg|png|gif)$/i.test(goods.image)
                                                                      ? `${axios.defaults.commonImageURL}/Courier/${goods.image}`
                                                                      : imagePreviews[`${index}-${goodsIndex}`] ||
                                                                      imagepreview
                                                                  }
                                                                  alt="imgfor"
                                                                  disabled={isDisabled}
                                                                  className={classes.chooseFileButton}
                                                                  style={{
                                                                    maxWidth: '22px',
                                                                    maxHeight: '22px',
                                                                    minWidth: '22px',
                                                                    minHeight: '22px',
                                                                    objectFit: 'contain',
                                                                    cursor: 'pointer',
                                                                  }}
                                                                />
                                                                <input
                                                                  className={classes.fileInput}
                                                                  id={`fileInput-${index}-${goodsIndex}`}
                                                                  type="file"
                                                                  accept="image/jpeg"
                                                                  name="IDcardFile"
                                                                  disabled={isDisabled}
                                                                  onChange={(event) => {
                                                                    handleFileChange(event, index, goodsIndex);
                                                                  }}
                                                                  style={{ display: 'none' }}
                                                                />
                                                              </label>
                                                            </Box>
                                                          </Stack>
                                                        </Stack>
                                                      </Stack>
                                                    )}
                                                    {goods.newGoods === 'Y' && (
                                                      <IconButton
                                                        aria-label=""
                                                        onClick={() => {
                                                          handleOpenDialog(index, goodsIndex, goods);
                                                        }}
                                                        color="primary"
                                                      >
                                                        <InfoIcon />
                                                      </IconButton>
                                                    )}
                                                    {box.goods.length > 1 && (
                                                      <IconButton
                                                        aria-label="delete"
                                                        onClick={() => handleDeleteGoods(index, goodsIndex)}
                                                        disabled={isDisabled}
                                                        color="error"
                                                      >
                                                        <HighlightOffIcon />
                                                      </IconButton>
                                                    )}
                                                  </Stack>
                                                </Grid>
                                              </Grid>
                                            </Paper>
                                          </Grid>
                                        );
                                      })}
                                    </Grid>
                                    <Stack justifyContent={'center'} alignItems={'center'} mt={2}>
                                      <Button
                                        onClick={() => {
                                          handleAddGoods(index, 'N');
                                        }}
                                        disabled={isDisabled}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        startIcon={<AddIcon />}
                                      >
                                        Add More Item
                                      </Button>
                                    </Stack>
                                    <Typography variant="h6" align="right" color="#347928" mt={2} mx={2}>
                                      Total: {getTotalValue(index)}
                                    </Typography>
                                  </>
                                )}
                              </AccordionDetails>
                               
                                </Accordion>
                                <Grid item md={12} xs={12}>
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      sx={{
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        width: '100%',
                                      }}
                                    >
                                      <Typography variant="h6" align="left" color="#295F98"
                                      sx={{pb:1}}>
                                        Dimensions & Weights
                                      </Typography>
                                     
                                    </Stack>
                                  </Grid>
                                  <Grid
                                    item
                                    md={box.goods.length > 0 ? 12 : 11}
                                    xs={12}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          size="small"
                                          fullWidth
                                          label="Length"
                                          type="number"
                                          value={box.length}
                                          disabled={isDisabled}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newLength = parseFloat(e.target.value) || '';
                                            if (newLength > 0 || newLength === '') {
                                              updatedBoxes[index].length = newLength;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (box.height * box.width * newLength) / 5000
                                                  : (box.height * box.width * newLength) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only
                                              if (newLength >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].length`}
                                          onBlur={handleBlur}
                                          // error={Boolean(
                                          //   errors[`boxDetails[${index}].length`] &&
                                          //   touched[`boxDetails[${index}].length`]
                                          // )}
                                          error={Boolean(
                                            errors.boxDetails?.[index]?.length && touched.boxDetails?.[index]?.length
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].length`] &&
                                            errors[`boxDetails[${index}].length`]
                                          }
                                          required
                                        />
                                        {errors.length && touched.length && <div>{errors.length}</div>}
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="Width"
                                          type="number"
                                          value={box.width}
                                          disabled={isDisabled}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newWidth = parseFloat(e.target.value) || '';
                                            if (newWidth > 0 || newWidth === '') {
                                              updatedBoxes[index].width = newWidth;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (box.height * box.length * newWidth) / 5000
                                                  : (box.height * box.length * newWidth) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only
                                              if (newWidth >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].width`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].width`] &&
                                            touched[`boxDetails[${index}].width`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].width`] &&
                                            errors[`boxDetails[${index}].width`]
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="Height"
                                          type="number"
                                          value={box.height}
                                          disabled={isDisabled}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];

                                            const newHeight = parseFloat(e.target.value) || '';
                                            if (newHeight > 0 || newHeight === '') {
                                              updatedBoxes[index].height = newHeight;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (newHeight * box.length * box.width) / 5000
                                                  : (newHeight * box.length * box.width) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only
                                              if (newHeight >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].height`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].height`] &&
                                            touched[`boxDetails[${index}].height`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].height`] &&
                                            errors[`boxDetails[${index}].height`]
                                          }
                                          required
                                        />
                                      </Grid>
                                      {/* <Grid item md={2} xs={12}>
                                        <Autocomplete
                                          fullWidth
                                          size="small"
                                          options={DimensionType} // Array of goods options
                                          getOptionLabel={(option) => option.label || ''} // Customize display value
                                          renderOption={(props, option) => (
                                            <li {...props} key={option.value}>
                                              {option.label}
                                            </li>
                                          )}
                                          value={DimensionType.find((item) => item.value === box.dimensionType) || null}
                                          disabled={isDisabled}
                                          onChange={(event, value) => {
                                            const updatedBoxes = [...boxDetails];
                                            updatedBoxes[index] = {
                                              ...updatedBoxes[index],
                                              dimensionType: value ? value.value : null, // Set the selected value
                                            };
                                            const rawCubicWeight =
                                              value.value === 'CM'
                                                ? (box.height * box.length * box.width) / 5000
                                                : (box.height * box.length * box.width) / 1925;
                                            updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                            setBoxDetails(updatedBoxes);
                                          }}
                                          isOptionEqualToValue={(option, value) => option.value === value?.value}
                                          required
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Dimension"
                                              required
                                              name={`boxDetails[${index}].dimensionType`}
                                              onBlur={handleBlur}
                                              error={Boolean(
                                                errors[`boxDetails[${index}].dimensionType`] &&
                                                touched[`boxDetails[${index}].dimensionType`]
                                              )}
                                              helperText={
                                                touched[`boxDetails[${index}].dimensionType`] &&
                                                errors[`boxDetails[${index}].dimensionType`]
                                              }
                                            />
                                          )}
                                        />
                                      </Grid> */}
                                      <Grid item md={3} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="Cubic Weight (kg)"
                                          type="number"
                                          value={box.cubicWeight === 0 ? '' : box.cubicWeight}
                                          disabled
                                          // onChange={(e) => {
                                          //   const updatedBoxes = [...boxDetails];
                                          //   updatedBoxes[index].cubicWeight = e.target.value;
                                          //   setBoxDetails(updatedBoxes);
                                          // }}
                                          name={`boxDetails[${index}].cubicWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].cubicWeight`] &&
                                            touched[`boxDetails[${index}].cubicWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].cubicWeight`] &&
                                            errors[`boxDetails[${index}].cubicWeight`]
                                          }
                                          required
                                        />
                                      </Grid>
                                      <Grid item md={3} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="Gross Weight (kg)"
                                          type="number"
                                          value={box.grossWeight}
                                          disabled={isDisabled}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newGrossWeight = parseFloat(e.target.value) || '';
                                            if (newGrossWeight > 0 || newGrossWeight === '') {
                                              updatedBoxes[index].grossWeight = newGrossWeight;
                                              setBoxDetails(updatedBoxes);
                                              GetShipperPrice(updatedBoxes);
                                              
                                              // Check for overweight condition on current box only
                                              if (newGrossWeight >= 31) {
                                                showOverweightWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].grossWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].grossWeight`] &&
                                            touched[`boxDetails[${index}].grossWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].grossWeight`] &&
                                            errors[`boxDetails[${index}].grossWeight`]
                                          }
                                          required
                                        />
                                      </Grid>
                                     
                                    </Grid>
                                  </Grid>
                                  </Paper>
                          </Grid>
                        ))}
                      {/* {Origin === 'IN' && ( */}
                      <Grid item md={12} xs={12}>
                        <Stack direction="row" justifyContent="center" sx={{ width: '100%' }} p={0} m={0}>
                          <Button
                            variant="contained"
                            color={'info'}
                            size="small"
                            sx={{ boxShadow: 1 }}
                            onClick={() => {
                              handleAddBox(setFieldValue, values);
                              // setFieldValue('NofoBoxes', boxDetails.length + 1);
                            }}
                            disabled={isDisabled}
                            fullWidth
                          >
                            Add Another Box
                          </Button>
                        </Stack>
                      </Grid>
                      {/* )} */}


                      {/* <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Collection Date"
                          type="date"
                          
                          name="collectionDate"
                          InputLabelProps={{ shrink: true }}
                          onBlur={handleBlur}
                          error={touched.collectionDate && !!errors.collectionDate}
                          helperText={touched.collectionDate && errors.collectionDate ? errors.collectionDate : ''}
                          value={values.collectionDate}
                          onChange={handleChange}
                        />
                      </Grid> */}

                      {/* Terms and Conditions Checkbox */}
                      <Grid item xs={12}>
                        <Stack direction="column" alignItems="center" gap={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={isDisabled}
                                checked={values.acceptTerms}
                                // onChange={handleChange}
                                onChange={(e) => {
                                  if (!values.acceptTerms) { // Only open dialog if the box isn't already checked
                                    setTermsDialogOpen(true);
                                  }
                                   if (e.target.checked) {
                                    setTC(true);
                                  }
                                  else{                         
                                       setTC(false);
                                      }
                                  handleChange(e); // Formik's handler to update the checkbox state
                                }}
                                name="acceptTerms"
                                color="primary"
                                inputRef={el => { fieldRefs.current.acceptTerms = el; }}
                              />
                            }
                            label={
                              <span>
                                I agree to the{' '}
                                <Button
                                  variant="text"
                                  size="small"
                                  onClick={() => {
                                    setTermsDialogOpen(true);
                                  }}
                                  disabled={isDisabled}
                                  sx={{ textTransform: 'none', padding: 0, color: 'primary.main' }}
                                >
                                  terms and conditions
                                </Button>
                              </span>
                            }
                          />
                          {touched.acceptTerms && errors.acceptTerms && (
                            <Typography variant="caption" color="error">
                              {errors.acceptTerms}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </>
                  )}
                </Grid>

                {bookingStarted && (
                  <>
                   <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1050,
                    //  bgcolor: '#7ca3e94f', 
                     bgcolor: 'transparent',
                     py: 1.5, pl: { xs: 0, lg: navOpen ? '250px' : '0px' } }}>
                    <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center' }}>
                     
                      <Button
                        onClick={() => {
                          setOpen(!open);
                          setEditID('');
                          setInitialValue({ ...resetStates });
                          navigate('/dashboard/manage/booking');
                        }}
                        variant="contained"
                        color="warning"
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                        {Status === 'A' ? 'Back' : 'Cancel'}
                      </Button>

                  {Type === 'Edit' && isDraft &&  <Button
                        onClick={handleOpenDeleteDialog}
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                        {/* <DeleteForeverIcon />  */}
                        Delete
                      </Button>
                  }

                      {Status !== 'A' && (
                        <Button
                          onClick={() => {handleValidationFlow(values, validateForm)
                           
                          }}
                          
                          disabled={isSubmitting}
                          variant="contained"
                          color="primary"
                          size="success"
                          sx={{ boxShadow: 1 }}
                        >
                          {Type === 'Edit' && !isDraft ? 'Update Order' : 'Complete Order'}
                        </Button>
                        
                      )}
                     { (isDraft && Status !== 'A') &&   <Button
                        onClick={() => {
                          submitCourierOrder({ ...initialValue, ...values },'Y');
                        }}
                        variant="contained"
                        color="inherit"
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                       Save As Draft
                      </Button>}
                      
                    </Stack>
                   </Box>
                   {/* <Box sx={{ height: 72 }} /> */}
                  </>
                )}


                       {/* Confirmation Dialog */}
                      <Dialog open={submitConfirmation} onClose={() => setSubmitConfirmation(false)}>
                        <DialogTitle>Confirm Submission</DialogTitle>
                        <DialogContent>
                          <p>Are you sure you want to submit?</p>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setSubmitConfirmation(false)} color="warning" variant="contained">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              if (values.receiverCountry.length === 0) {
                                setreceiverCountryErr(true);
                              } else {
                                setreceiverCountryErr(false);
                              }
                              if (values.senderCountry.length === 0) {
                                setsenderCountryErr(true);
                              } else {
                                setsenderCountryErr(false);
                              }
                              submitForm();
                              setSubmitConfirmation(false);
                            }}
                            disabled={isSubmitting}
                            variant="contained"
                            color="primary"
                            size="success"
                            sx={{ boxShadow: 1 }}
                          >
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                {/* Confirmation Dialog for Deletion */}
                <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
                  <DialogTitle>Confirm Deletion</DialogTitle>
                  <DialogContent>
                    <Typography>Are you sure you want to delete this box?</Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseConfirmDialog} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={async () => {
                        showLoading();
                        setInitialValue(values);
                        const updatedBoxDetails = [...boxDetails];
                        updatedBoxDetails.splice(boxToDelete, 1);
                        const reIndexedBoxDetails = updatedBoxDetails.map((box, index) => ({
                          ...box,
                          boxNo: index + 1,
                        }));

                        setBoxDetails(reIndexedBoxDetails);
                        GetShipperPrice(reIndexedBoxDetails);
                        setTimeout(async () => {
                          await new Promise((resolve) => {
                            setFieldValue('NofoBoxes', reIndexedBoxDetails.length, () => resolve());
                          });
                        }, 1000);
                        hideLoading();
                        handleCloseConfirmDialog();
                      }}
                      color="error"
                    >
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Delete Order Confirmation Dialog */}
                <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog} fullWidth maxWidth="xs">
                  <DialogTitle sx={{ textAlign: 'center' }}>Confirm Delete Order</DialogTitle>
                  <DialogContent>
                    <Typography>Are you sure you want to delete this order? This action cannot be undone.</Typography>
                  </DialogContent>
                  <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: 2 }}>
                    <Button variant="contained" onClick={handleCloseDeleteDialog} color="primary">
                      Cancel
                    </Button>
                    <Button variant="contained" onClick={deleteOrder} color="error">
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Confirmation reset Dialog */}
                <Dialog
                  open={resetOpenDialog}
                  onClose={() => setResetOpenDialog(false)}
                  aria-labelledby="confirm-dialog-title"
                  aria-describedby="confirm-dialog-description"
                >
                  <DialogTitle id="confirm-dialog-title">Confirm Reset</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                      Are you sure you want to reset the form? This action cannot be undone.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setResetOpenDialog(false)} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        resetForm();
                        resetBooking();
                        setErrors({});
                        setTouched({});
                        setSenderImageFile(null);
                        setSenderImagePreview('');
                        setReceiverImageFile(null);
                        setReceiverImagePreview('');
                        setsameAsSender(false);
                        setResetOpenDialog(false);
                      }}
                      color="error"
                      autoFocus
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Confirmation Dialog for Change Country */}
                <Dialog open={openConfirmDialog1} onClose={handleCloseConfirmDialog1}>
                  <DialogTitle>Change Country</DialogTitle>
                  <DialogContent>
                    <Typography>{changeContent}</Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseConfirmDialog1} color="warning">
                      Close
                    </Button>
                    {/* <Button onClick={() => changeCountry(setFieldValue)} color="error">
                      Change
                    </Button> */}
                  </DialogActions>
                </Dialog>

                {/* Dialog for Preview */}
                <Dialog open={dialogOpen} fullWidth maxWidth="sm">
                  <DialogTitle>Goods Preview</DialogTitle>
                  <DialogContent>
                    {selectedGoods && (
                      <Grid container spacing={1} p={1}>
                        <Grid item md={12} xs={12}>
                          <Stack direction="column" spacing={2}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              border={1}
                              borderRadius={1}
                              borderColor="#e0e0e0"
                              p={1}
                              justifyContent="center"
                            >
                              <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                <Box title="delete image">
                                  <label htmlFor={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}>
                                    <img
                                      src={
                                        /\.(jpg|jpeg|png|gif)$/i.test(selectedGoods?.goods?.image)
                                          ? `${axios.defaults.commonImageURL}/Courier/${selectedGoods?.goods?.image}`
                                          : imagePreviews[`${selectedGoods?.index}-${selectedGoods?.goodsIndex}`] ||
                                          imagepreview
                                      }
                                      alt="Preview"
                                      className={classes.chooseFileButton}
                                      style={{
                                        maxWidth: '100px',
                                        maxHeight: '100px',
                                        minWidth: '100px',
                                        minHeight: '100px',
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                        position: 'relative',
                                      }}
                                    />
                                    <IconButton
                                      id={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}
                                      style={{
                                        position: 'absolute',
                                        top: '70px',
                                        right: '50px',
                                        background: 'white',
                                        zIndex: 10,
                                      }}
                                      onClick={() => {
                                        handleDeleteImage();
                                        handleCloseDialog();
                                      }}
                                    >
                                      <DeleteForeverIcon color="error" />
                                    </IconButton>
                                    <input
                                      className={classes.fileInput}
                                      id={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}
                                      type="file"
                                      accept="image/jpeg"
                                      name="IDcardFile"
                                      onChange={(event) => {
                                        handleFileChange(
                                          event,
                                          'image',
                                          selectedGoods?.index,
                                          selectedGoods?.goodsIndex
                                        );
                                      }}
                                      style={{ display: 'none' }}
                                    />
                                  </label>
                                </Box>
                              </Stack>
                            </Stack>
                          </Stack>
                        </Grid>

                        <Grid item md={12} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Goods Name{' '}
                            <Typography variant="h6" color="#009688">
                              {selectedGoods?.goods?.goodsName}
                            </Typography>
                          </Typography>
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            UOM{' '}
                            <Typography variant="h6" color="#009688">
                              {uomList.find((uom) => Number(uom.UOM_Id) === Number(selectedGoods?.goods?.UOM_Id))
                                ?.UOM_Description || ''}
                            </Typography>
                          </Typography>
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Quantity{' '}
                            <Typography variant="h6" color="#009688">
                              {selectedGoods?.goods?.quantity}
                            </Typography>
                          </Typography>
                        </Grid>

                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Rate{' '}
                            <Typography variant="h6" color="#009688">
                              {selectedGoods?.goods?.rate}
                            </Typography>
                          </Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            Value{' '}
                            <Typography variant="h6" color="#009688">
                              {selectedGoods?.goods?.value}
                            </Typography>
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                    <Stack justifyContent={'center'} direction={'row'} spacing={2} alignItems={'center'}>
                      <Button onClick={handleCloseDialog} color="warning" variant="contained" size="small">
                        Close
                      </Button>
                    </Stack>
                  </DialogContent>
                </Dialog>

              <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
  <DialogTitle>Image Preview</DialogTitle>
  <DialogContent>
    <img
      src={
        previewTarget === 'sender'
          ? (senderImagePreview || imagepreview)
          : previewTarget === 'receiver'
          ? (receiverImagePreview || imagepreview)
          : (imagePreview || imagepreview)
      }
      alt="Preview"
      style={{
        maxWidth: '100%',
        maxHeight: '400px',
        objectFit: 'contain',
      }}
    />
  </DialogContent>
  <DialogActions>
    <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
      <Stack direction="row" spacing={1}>
        <Button
          onClick={handleOpenConfirmDialogDelete}
          color="error"
          variant="outlined"
          size="small"
          startIcon={<DeleteOutlineIcon />}
        >
          Delete
        </Button>
        
        {/* Download Button */}
        <Button
          onClick={() => {
            // Determine which image to download
            let imageUrl = '';
            let fileName = '';
            
            if (previewTarget === 'sender') {
              imageUrl = senderImagePreview;
              fileName = `ID_card_${values.IdCardNo || 'unknown'}.jpg`;
            } else if (previewTarget === 'receiver') {
              imageUrl = receiverImagePreview;
              fileName = `ID_card_${values.RecIdCardNo || 'unknown'}.jpg`;
            }
            
            // Download the image
            if (imageUrl && imageUrl !== imagepreview) {
              const link = document.createElement('a');
              link.href = imageUrl;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              openSnackBar('No image available to download', 'warning');
            }
          }}
          color="primary"
          variant="contained"
          size="small"
          startIcon={<FileDownloadIcon />}
        >
          Download
        </Button>
      </Stack>
      
      <Button
        onClick={handleCloseDialogPreview}
        color="primary"
        startIcon={<CloseIcon />}
        variant="outlined"
        size="small"
      >
        Close
      </Button>
    </Stack>
  </DialogActions>
</Dialog>

                         <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                                                  <DialogTitle>Confirm Deletion</DialogTitle>
                                                  <DialogContent>
                                                    <Typography>Are you sure you want to delete this image?</Typography>
                                                  </DialogContent>
                                                  <DialogActions>
                                                    <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                                                      Cancel
                                                    </Button>
                                                    <Button
                                                     onClick={() => {
                        if (previewTarget === 'sender') {
                          setSenderImageFile(null);
                          setSenderImagePreview('');
                          setFieldValue('IdCardNo', '');
                          // Reset the sender file input
                        const senderInput = document.getElementById('fileInputSender');
                        if (senderInput) {
                          senderInput.value = '';
                        }
                        } else if (previewTarget === 'receiver') {
                          setReceiverImageFile(null);
                          setReceiverImagePreview('');
                           setFieldValue('RecIdCardNo', '');
                          // Reset the receiver file input
                            const receiverInput = document.getElementById('fileInputReceiver');
                            if (receiverInput) {
                              receiverInput.value = '';
                            }
                        } else {
                          setSelectedImageFile(null);
                        }
                        setOpenDialogPreview(false);
                        handleCloseDialogPreview();
                        handleCloseConfirmDialogDelete();
                      }}
                                                      color="error"
                                                    >
                                                      Delete
                                                    </Button>
                                                  </DialogActions>
                                                </Dialog>

                {/* Terms and Conditions Dialog */}
                <Dialog open={termsDialogOpen} maxWidth="md" fullWidth>
                  <DialogTitle>Terms and Conditions</DialogTitle>
                  <DialogContent
                    ref={contentRef}
                    dividers
                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                    onScroll={handleScroll}
                  >
                    <TermsAndCondition />
                  </DialogContent>
                  <DialogActions>
                    {/* <Button
                      onClick={() => {
                        setFieldValue("acceptTerms", false);
                        setTermsDialogOpen(false)
                      }} variant="outlined" color="secondary">
                      Decline
                    </Button> */}
                    <Button
                      onClick={() => {
                        setFieldValue("acceptTerms", true);
                        setTC(true)
                        setTermsDialogOpen(false);
                      }}
                      variant="contained"
                      color="primary"
                      disabled={!isScrolledToBottom}
                    >
                      Accept
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Shipper Price Dialog */}
                {cardToggle && shipperPriceData.length > 0 && shipperPriceData[0].weight > 0 && (
                <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 1100 }}>
                  <Paper
                    elevation={isMinimized ? 1 : 3}
                    sx={{
                      width: isMinimized ? '200px' : '300px',
                      height: isMinimized ? 'auto' : 'auto',
                      maxHeight: isMinimized ? '60px' : '400px',
                      borderRadius: '16px',
                      backgroundColor: '#1a1a2e',
                      color: 'white',
                      padding: isMinimized ? '12px 16px' : 3,
                      position: 'relative',
                      textAlign: 'center',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      overflow: 'hidden',
                      transform: isMinimized ? 'scale(0.95)' : 'scale(1)',
                      opacity: isMinimized ? 0.9 : 1,
                    }}
                  >
                    {/* Header Section */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        mb: isMinimized ? 0 : 2,
                        transition: 'margin-bottom 0.3s ease',
                      }}
                    >
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'rgba(255, 255, 255, 0.7)', 
                          fontWeight: 500,
                          fontSize: isMinimized ? '0.875rem' : '0.9rem',
                          transition: 'font-size 0.3s ease',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {isMinimized ? (
                          `Price Details - ${shipperPriceData.length} options`
                        ) : (
                          'Price Details'
                        )}
                      </Typography>
                      
                      <Stack direction="row" spacing={0.5}>
                        {/* Minimize Button */}
                        <IconButton
                          aria-label="minimize"
                          onClick={() => setIsMinimized(!isMinimized)}
                          sx={{
                            color: 'white',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            '&:hover': {
                              backgroundColor: 'rgba(255, 255, 255, 0.4)',
                            },
                            padding: '4px',
                            fontSize: '0.875rem',
                            transition: 'transform 0.3s ease',
                            transform: isMinimized ? 'rotate(180deg)' : 'rotate(0deg)',
                          }}
                          size="small"
                        >
                          <ExpandLessIcon />
                        </IconButton>
                        
                        {/* Close Button */}
                        <IconButton
                          aria-label="close"
                          onClick={() => setCardToggle(false)}
                          sx={{
                            color: 'white',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            '&:hover': {
                              backgroundColor: 'rgba(255, 255, 255, 0.4)',
                            },
                            padding: '4px',
                            fontSize: '0.875rem',
                          }}
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Stack>
                    </Stack>

                    {/* Content Container - Uses CSS transitions */}
                    <Box
                      sx={{
                        maxHeight: isMinimized ? '0px' : '400px',
                        opacity: isMinimized ? 0 : 1,
                        overflow: 'hidden',
                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                        visibility: isMinimized ? 'hidden' : 'visible',
                      }}
                    >
                      {/* Title */}
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 'bold',
                          mb: 2,
                          textAlign: 'center',
                          fontSize: '1.1rem',
                          opacity: isMinimized ? 0 : 1,
                          transform: isMinimized ? 'translateY(-10px)' : 'translateY(0)',
                          transition: 'opacity 0.3s ease, transform 0.3s ease',
                        }}
                      >
                        {`${getCountryName(values.senderCountry)} - ${getCountryName(values.receiverCountry)} for ${shipperPriceData[0].weight || 0} kgs (approximately)`}
                      </Typography>

                      {/* Scrollable Content */}
                      <Box
                        sx={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          opacity: isMinimized ? 0 : 1,
                          transform: isMinimized ? 'translateY(-20px)' : 'translateY(0)',
                          transition: 'opacity 0.4s ease 0.1s, transform 0.4s ease 0.1s',
                          '&::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '&::-webkit-scrollbar-track': {
                            background: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            background: 'rgba(255, 255, 255, 0.3)',
                            borderRadius: '3px',
                            '&:hover': {
                              background: 'rgba(255, 255, 255, 0.4)',
                            },
                          },
                        }}
                      >
                        {/* Dynamic Mapping of Shipper Prices */}
                        {shipperPriceData.map((item, index) => {
                          const isSelected = values.shipper === item.ShipperLinerName;
                          
                          return (
                            <Stack
                              key={index}
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              sx={{
                                padding: '8px 16px',
                                borderBottom: index < shipperPriceData.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                                backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                                '&:hover': {
                                  backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                                  cursor: 'pointer',
                                },
                                transition: 'all 0.2s ease',
                                opacity: isMinimized ? 0 : 1,
                                transform: isMinimized ? 'translateY(-10px)' : 'translateY(0)',
                                animation: isMinimized ? 'none' : `fadeInUp 0.3s ease ${index * 0.05}s both`,
                              }}
                              onClick={() => {
                                if (!isMinimized) {
                                  setFieldValue('shipper', item.ShipperLinerName || '');
                                  setShipperId(item.ShipperLinerId);
                                  setFieldTouched('shipper', true);
                                  setTimeout(() => {
                                     setIsMinimized(!isMinimized)
                                  },800)
                                }
                              }}
                            >
                              {/* Left side: Radio button and Shipper Name */}
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: '50%',
                                    border: '2px solid rgba(255, 255, 255, 0.5)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  {isSelected && (
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        backgroundColor: 'white',
                                        transition: 'all 0.2s ease',
                                      }}
                                    />
                                  )}
                                </Box>
                                <Typography
                                  variant="body2"
                                  gutterBottom
                                  sx={{ 
                                    color: 'white',
                                    fontWeight: isSelected ? 600 : 400,
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  {item.ShipperLinerName || ''}
                                </Typography>
                              </Stack>

                              {/* Right side: Price */}
                              <Typography 
                                variant="body2" 
                                gutterBottom 
                                sx={{ 
                                  color: 'white',
                                  fontWeight: isSelected ? 600 : 400,
                                  transition: 'all 0.2s ease',
                                }}
                              >
                                {item.symbol}{numeral(item.Price).format('0,0.00')}
                              </Typography>
                            </Stack>
                          );
                        })}
                      </Box>
                    </Box>
                    
                    {/* Add CSS animation keyframes */}
                    <style>
                      {`
                        @keyframes fadeInUp {
                          from {
                            opacity: 0;
                            transform: translateY(10px);
                          }
                          to {
                            opacity: 1;
                            transform: translateY(0);
                          }
                        }
                      `}
                    </style>
                  </Paper>
                </div>
                )}
                </Form>
              );
            }}
          </Formik>{' '}
        </Container>
      </Container>
    </>
  );
};

export default CourierOrderCreation;
